var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuropaLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Oct  3 04:03:20 2013\n By ,,,\nCopyright (c) 2011 Fabian Leuenberger and EuropaType. All rights reserved. This Font Software may not be reproduced, modified, disclosed or transferred without the express written approval of EuropaType. EUROPA is a trademark of EuropaType and may be registered in certain jurisdictions. This Font Software is original artwork of Fabian Leuenberger and EuropaType. The design may be protected in certain jurisdictions.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Europa-Light",
    horizAdvX: 580
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Europa-Light",
    fontWeight: 300,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 782,
    descent: -218,
    xHeight: 456,
    capHeight: 700,
    bbox: "-195 -250 1048 974",
    underlineThickness: 38,
    underlinePosition: -153,
    unicodeRange: "U+0020-FB04"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 550,
    d: "M304 181q0 -12 -8.5 -21t-20.5 -9q-13 0 -22 9t-9 21t9 21t22 9q12 0 20.5 -9t8.5 -21zM338 436q0 25 -18.5 43t-45.5 18q-24 0 -43 -13.5t-25 -27.5l-7 -14l-38 19q1 3 3 8.5t11.5 19t21 23.5t32 18.5t45.5 8.5q44 0 76 -30t32 -73q0 -23 -11 -44.5t-20 -31t-26 -24.5 q-22 -18 -26 -25.5t-4 -24.5v-33h-42v33q0 27 6.5 40t32.5 35q2 2 12 11t13.5 13t9.5 12.5t8.5 18t2.5 20.5zM30 0v700h490v-700h-490zM70 663v-626h410v626h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffj",
    unicode: "ffj",
    horizAdvX: 785,
    d: "M515 -221l20 45q24 -15 46 -15q17 0 29 3.5t23.5 20.5t11.5 47v576h52v-584q0 -57 -32.5 -85.5t-75.5 -28.5q-19 0 -37.5 5t-27.5 11zM23 408v48h98v162q0 66 45.5 108t111.5 42q41 0 77 -19t54 -51q16 31 52 50.5t79 19.5q66 0 111.5 -42t45.5 -108v-26 q0 -11 -7.5 -18.5t-18.5 -7.5t-18.5 7.5t-7.5 18.5v14q0 47 -27 79t-78 32t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v606q0 47 -27 79t-78 32t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v408h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fft",
    unicode: "fft",
    horizAdvX: 925,
    d: "M173 619v-163h226v179q0 63 36.5 98t86.5 35q47 0 89 -22l-22 -45q-27 16 -58 16q-80 0 -80 -98v-163h224v147h52v-147h155v-48h-155v-280q0 -89 80 -89q16 0 33 5.5t26 10.5l9 5l20 -45q-44 -27 -90 -27q-63 0 -96.5 37t-33.5 96v287h-224v-408h-52v408h-226v-408h-52 v408h-98v48h98v179q0 63 36.5 98t86.5 35q47 0 89 -22l-22 -45q-27 16 -58 16q-80 0 -80 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ff",
    unicode: "ff",
    horizAdvX: 601,
    d: "M173 619v-163h226v179q0 63 36.5 98t86.5 35q47 0 89 -22l-22 -45q-27 16 -58 16q-80 0 -80 -98v-163h120v-48h-120v-408h-52v408h-226v-408h-52v408h-98v48h98v179q0 63 36.5 98t86.5 35q47 0 89 -22l-22 -45q-27 16 -58 16q-80 0 -80 -98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 523,
    d: "M23 408v48h98v162q0 66 45.5 108t111.5 42t111.5 -42t45.5 -108v-26q0 -11 -7.5 -18.5t-18.5 -7.5t-18.5 7.5t-7.5 18.5v14q0 47 -27 79t-78 32t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v408h-98zM383 0v456h52v-456h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 523,
    d: "M383 0v606q0 47 -27 79t-78 32t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v408h-98v48h98v162q0 66 45.5 108t111.5 42t111.5 -42t45.5 -108v-618h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffi",
    unicode: "ffi",
    horizAdvX: 785,
    d: "M23 408v48h98v162q0 66 45.5 108t111.5 42q41 0 77 -19t54 -51q16 31 52 50.5t79 19.5q66 0 111.5 -42t45.5 -108v-26q0 -11 -7.5 -18.5t-18.5 -7.5t-18.5 7.5t-7.5 18.5v14q0 47 -27 79t-78 32t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v606q0 47 -27 79t-78 32 t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v408h-98zM645 0v456h52v-456h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffl",
    unicode: "ffl",
    horizAdvX: 785,
    d: "M23 408v48h98v162q0 66 45.5 108t111.5 42q41 0 77 -19t54 -51q16 31 52 50.5t79 19.5q66 0 111.5 -42t45.5 -108v-618h-52v606q0 47 -27 79t-78 32t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v606q0 47 -27 79t-78 32t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v408 h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 550,
    d: "M304 181q0 -12 -8.5 -21t-20.5 -9q-13 0 -22 9t-9 21t9 21t22 9q12 0 20.5 -9t8.5 -21zM338 436q0 25 -18.5 43t-45.5 18q-24 0 -43 -13.5t-25 -27.5l-7 -14l-38 19q1 3 3 8.5t11.5 19t21 23.5t32 18.5t45.5 8.5q44 0 76 -30t32 -73q0 -23 -11 -44.5t-20 -31t-26 -24.5 q-22 -18 -26 -25.5t-4 -24.5v-33h-42v33q0 27 6.5 40t32.5 35q2 2 12 11t13.5 13t9.5 12.5t8.5 18t2.5 20.5zM30 0v700h490v-700h-490zM70 663v-626h410v626h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 272
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 256,
    d: "M154 700v-519h-52v519h52zM88 28q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 334,
    d: "M80 462v238h50v-238h-50zM204 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 634,
    d: "M194 -14l-49 7l34 245h-128v48h135l20 144h-130v48h136l34 237l49 -7l-33 -230h141l34 237l49 -7l-33 -230h132v-48h-138l-20 -144h133v-48h-140l-35 -252l-49 7l34 245h-141zM256 430l-20 -144h141l20 144h-141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M281 -92v81q-40 3 -75.5 18.5t-57.5 35.5t-38.5 40t-23.5 34l-7 14l47 28q2 -4 5.5 -11.5t16.5 -27t29.5 -35t44 -29.5t59.5 -17v300q-83 38 -128.5 83.5t-45.5 115.5q0 62 46 114.5t128 58.5v81h43v-81q31 -3 59.5 -14.5t47.5 -25.5t33.5 -27.5t21.5 -22.5l6 -9l-40 -31 q-2 3 -5.5 7.5t-15.5 17t-25.5 22.5t-35.5 19.5t-46 12.5v-284l14 -6q85 -37 126 -82t41 -113q0 -76 -51 -127t-130 -59v-81h-43zM453 175q0 52 -33.5 84.5t-95.5 60.5v-279q57 8 93 43.5t36 90.5zM159 538q0 -48 31 -80.5t91 -61.5v264q-56 -6 -89 -39.5t-33 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 712,
    d: "M189 712q65 0 111 -45t46 -110t-46 -110t-111 -45t-111 45t-46 110t46 110t111 45zM523 298q65 0 111 -45t46 -110t-46 -110t-111 -45t-111 45t-46 110t46 110t111 45zM80 557q0 -45 31.5 -77t77.5 -32t77.5 32t31.5 77t-31.5 77t-77.5 32t-77.5 -32t-31.5 -77zM414 143 q0 -45 31.5 -77t77.5 -32t77.5 32t31.5 77t-31.5 77t-77.5 32t-77.5 -32t-31.5 -77zM91 -3l475 730l35 -24l-475 -730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 699,
    d: "M560 384h51q0 -69 -11 -126.5t-22 -80.5l-11 -23l128 -114l-33 -39l-123 110q-38 -50 -105.5 -86.5t-136.5 -36.5q-101 0 -161 48t-60 117q0 23 8 44.5t17.5 37t38 40.5t47 40t66.5 52q-51 46 -72.5 67.5t-40.5 55t-19 67.5q0 63 48.5 109t127.5 46t127.5 -46t48.5 -109 q0 -49 -28.5 -86t-112.5 -107l197 -176q3 5 8.5 17t14 62t8.5 117zM297 39q63 0 118.5 31.5t86.5 73.5l-213 191q-12 -9 -35 -26.5t-34 -26.5t-28.5 -23.5t-26 -24.5t-18 -22.5t-13.5 -24.5t-4 -24q0 -62 47.5 -93t119.5 -31zM174 557q0 -25 14.5 -51t27.5 -39t44 -39.5 t37 -31.5q72 57 97.5 87.5t25.5 73.5q0 45 -34.5 74.5t-88.5 29.5t-88.5 -29.5t-34.5 -74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 150,
    d: "M50 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 308,
    d: "M265 -130l-42 -29q-80 120 -118.5 223t-38.5 231t38.5 231t118.5 223l42 -29q-74 -110 -109.5 -204.5t-35.5 -220.5t35.5 -220.5t109.5 -204.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 308,
    d: "M85 -159l-42 29q74 110 109.5 204.5t35.5 220.5t-35.5 220.5t-109.5 204.5l42 29q80 -120 118.5 -223t38.5 -231t-38.5 -231t-118.5 -223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 398,
    d: "M43 612l136 -44v144h40v-144l136 44l12 -38l-133 -43l82 -114l-33 -24l-84 115l-83 -115l-33 24l82 113l-134 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 520,
    d: "M486 262v-48h-201v-214h-50v214h-201v48h201v206h50v-206h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 219,
    d: "M32 -147l83 235l48 -17l-85 -234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 333,
    d: "M33 213v48h267v-48h-267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 212,
    d: "M66 28q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 485,
    d: "M458 773l-396 -899l-43 19l396 899z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 592,
    d: "M297 712q65 0 115 -30.5t79 -82.5t44 -115t15 -134t-15 -134t-44 -115t-79 -82.5t-115 -30.5t-115 30.5t-80 82.5t-45 115t-15 134t15 134t45 115t80 82.5t115 30.5zM297 39q68 0 114.5 48.5t65.5 116t19 146.5t-19 146.5t-65.5 116t-114.5 48.5t-115 -48.5t-66.5 -116 t-19.5 -146.5t19.5 -146.5t66.5 -116t115 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 388,
    d: "M28 552l185 148h43v-700h-52v626l-145 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 532,
    d: "M56 0l266 335q2 2 13.5 16t17 21t16 22.5t16.5 27t13 27t10 31.5t3 32q0 66 -39.5 107.5t-112.5 41.5q-34 0 -62.5 -12.5t-45 -30.5t-28.5 -36t-16 -30l-4 -13l-50 19q2 6 6 16.5t20.5 37t37.5 47t59 37t83 16.5q93 0 149.5 -56t56.5 -144q0 -20 -5.5 -41.5t-12.5 -38 t-18.5 -36t-18.5 -29.5t-17.5 -24t-11.5 -15l-222 -280h315v-48h-418z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 544,
    d: "M418 522q0 61 -41.5 100t-105.5 39q-33 0 -60.5 -10.5t-43 -25.5t-26 -30.5t-14.5 -26.5l-4 -10l-48 20q2 5 6 14.5t19.5 32.5t35.5 40.5t56 32t79 14.5q86 0 142.5 -54t56.5 -136q0 -32 -10 -61t-24.5 -47t-29 -31.5t-24.5 -18.5l-10 -6q5 -1 12.5 -4t26.5 -15.5t34 -30 t27 -50.5t12 -74q0 -89 -62.5 -142.5t-155.5 -53.5q-47 0 -87 16t-63 38t-39.5 44.5t-22.5 38.5l-6 16l49 24q1 -5 4.5 -13.5t17 -30.5t30.5 -38.5t48.5 -30t68.5 -13.5q73 0 119.5 40.5t46.5 104.5q0 67 -39.5 106.5t-116.5 39.5h-41v52h36q66 0 106.5 39.5t40.5 100.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 540,
    d: "M2 199l361 501h50v-453h97v-48h-97v-199h-52v199h-359zM95 247h266v370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 575,
    d: "M519 218q0 -103 -67.5 -166.5t-163.5 -63.5q-45 0 -84.5 15t-63 36t-40.5 42t-24 36l-6 15l47 26q2 -5 5.5 -13t18 -28.5t32.5 -36t48.5 -28.5t66.5 -13q74 0 125.5 50.5t51.5 128.5q0 79 -50 129t-129 50q-48 0 -94 -20.5t-68 -40.5l-22 -21v385h387v-48h-335v-241 q62 37 134 37q100 0 165.5 -63t65.5 -167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 548,
    d: "M353 694l-170 -278q39 23 93 23q101 0 162.5 -67t61.5 -156t-61.5 -158.5t-162.5 -69.5t-162.5 69t-61.5 157q0 61 34 126q16 29 72 124.5t104 175.5l49 81zM276 388q-75 0 -122.5 -47t-47.5 -125q0 -75 48.5 -126t121.5 -51t121.5 51t48.5 126t-48 123.5t-122 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 508,
    d: "M52 652v48h454l-368 -711l-44 24l331 639h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 564,
    d: "M282 712q88 0 141 -55.5t53 -128.5q0 -51 -25 -91.5t-63 -62.5q50 -24 81 -72t31 -109q0 -86 -61 -145.5t-157 -59.5t-157 59.5t-61 145.5q0 61 31 109t81 72q-38 22 -63 62.5t-25 91.5q0 73 53 128.5t141 55.5zM282 39q73 0 118.5 43.5t45.5 110.5t-45.5 110t-118.5 43 t-118.5 -43t-45.5 -110t45.5 -110.5t118.5 -43.5zM282 393q59 0 99.5 36.5t40.5 98.5t-40.5 97.5t-99.5 35.5t-99.5 -35.5t-40.5 -97.5t40.5 -98.5t99.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 548,
    d: "M201 9l164 275q-39 -23 -93 -23q-101 0 -162.5 67.5t-61.5 155.5t61.5 158t162.5 70t162.5 -69t61.5 -157q0 -61 -34 -126l-219 -378zM272 312q75 0 122.5 47t47.5 125q0 75 -48.5 126t-121.5 51t-121.5 -51t-48.5 -126t48 -123.5t122 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 220,
    d: "M70 28q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM70 428q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 219,
    d: "M74 428q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM32 -147l83 235l48 -17l-85 -234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 520,
    d: "M12 244v54l462 198v-52l-407 -173l407 -173v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 520,
    d: "M55 287v48h410v-48h-410zM55 151v48h410v-48h-410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 520,
    d: "M508 298v-54l-462 -198v52l407 173l-407 173v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 478,
    d: "M372 529q0 58 -38 95t-105 37q-36 0 -64 -11t-43.5 -27.5t-25.5 -32.5t-13 -27l-3 -11l-49 16q1 6 4.5 15.5t18 34.5t34.5 44t57.5 34.5t83.5 15.5q82 0 139.5 -51t57.5 -132q0 -39 -17.5 -73.5t-35.5 -52t-53.5 -45.5t-47.5 -40q-10 -10 -11.5 -17t-1.5 -32v-89h-52v90 q0 40 5 54.5t28 33.5l40.5 31.5t39.5 32.5t25 27.5t22 38t5 41.5zM193 28q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 799,
    d: "M585 72l17 -37q-88 -47 -192 -47q-150 0 -256 106t-106 256t106 256t256 106q148 0 244.5 -101t96.5 -246q0 -66 -15 -112t-39.5 -67t-46.5 -29t-45 -8q-31 0 -55 16.5t-28 51.5q-5 -8 -15.5 -19t-45 -30t-73.5 -19q-54 0 -99 33.5t-45 93.5q0 58 44.5 92t108.5 34 q30 0 59.5 -11t44.5 -22l15 -11v29q0 116 -115 116q-28 0 -57 -9.5t-44 -18.5l-15 -9l-21 38q63 41 138 41q73 0 115.5 -40t42.5 -106v-163q0 -45 48 -45q100 0 100 174q0 129 -83 217t-215 88q-135 0 -227 -93t-92 -227q0 -133 92.5 -226.5t226.5 -93.5q96 0 175 42z M400 191q34 0 63 18t41 36l12 18v51q-5 5 -14.5 12.5t-39.5 20.5t-61 13q-57 0 -85 -25.5t-28 -58.5q0 -37 29.5 -61t82.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 551,
    d: "M88 0v700h190q90 0 144.5 -49t54.5 -131q0 -37 -11 -67t-27 -47t-26.5 -25.5t-18.5 -11.5q10 -2 25 -10.5t39 -27.5t40.5 -56t16.5 -85q0 -86 -56.5 -138t-155.5 -52h-215zM140 48h158q85 0 124 41.5t39 100.5t-37 102.5t-112 43.5h-172v-288zM140 384h147q68 0 102 37.5 t34 98.5q0 59 -39.5 95.5t-110.5 36.5h-133v-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 673,
    d: "M390 39q68 0 126 27.5t97 73.5l36 -36q-100 -116 -259 -116q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5t249 -107l-37 -34q-82 90 -212 90q-128 0 -210 -90t-82 -221t82 -221t210 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 669,
    d: "M88 700h191q151 0 248.5 -99t97.5 -251t-97.5 -251t-248.5 -99h-191v700zM140 48h129q137 0 219.5 83t82.5 219t-82.5 219t-219.5 83h-129v-604z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 521,
    d: "M140 650v-267h311v-48h-311v-335h-52v700h383v-50h-331z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 724,
    d: "M422 319v49h242v-286q-4 -4 -11.5 -10t-34 -22.5t-56 -29t-76.5 -22.5t-97 -10q-153 0 -249 104t-96 258q0 153 97.5 257.5t247.5 104.5q77 0 140.5 -25t88.5 -49l25 -25l-37 -35q-3 3 -8.5 9t-25 20t-42.5 25t-61 20t-80 9q-127 0 -209 -89.5t-82 -221.5q0 -133 80 -222 t211 -89q67 0 123 16.5t78 32.5l23 17v214h-191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 683,
    d: "M543 383v317h52v-700h-52v335h-403v-335h-52v700h52v-317h403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 466,
    d: "M326 190v510h52v-510q0 -96 -50.5 -149t-135.5 -53q-33 0 -63.5 10.5t-50.5 25t-35.5 29.5t-22.5 25l-7 11l40 33q2 -3 5.5 -9t16.5 -20t27.5 -25t39 -20t50.5 -9q68 0 101 42.5t33 108.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 569,
    d: "M140 700v-337l311 337h68l-317 -343l367 -357h-75l-354 343v-343h-52v700h52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 488,
    d: "M88 0v700h52v-652h334v-48h-386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 810,
    d: "M88 700h49l268 -430l268 430h49v-700h-52v597l-265 -422l-266 421v-596h-51v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 710,
    d: "M88 700h52l430 -610v610h52v-700h-52l-430 612v-612h-52v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 780,
    d: "M390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5t-210.5 89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 514,
    d: "M88 0v700h179q100 0 160.5 -57.5t60.5 -145.5t-60.5 -145.5t-160.5 -57.5h-127v-294h-52zM140 342h128q74 0 120 43t46 112t-46 112t-120 43h-128v-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 789,
    d: "M390 712q150 0 248 -104.5t98 -257.5q0 -140 -85 -243l100 -89l-32 -38l-103 91q-94 -83 -226 -83q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5zM442 227l33 39l137 -124q70 88 70 208q0 131 -82 221t-210 90t-210 -90t-82 -221t82 -221t210 -90q109 0 187 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 537,
    d: "M140 354h120q79 0 124.5 39.5t45.5 108.5t-46 108.5t-124 39.5h-120v-296zM88 0v700h169q106 0 166.5 -55t60.5 -143q0 -43 -14.5 -77.5t-35 -55t-47 -35t-46.5 -20t-38 -7.5l200 -307h-63l-196 304h-104v-304h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 536,
    d: "M428 175q0 25 -9.5 46.5t-22 36t-36.5 29.5t-41.5 23.5t-48.5 22.5q-90 39 -139 85.5t-49 119.5q0 66 52 120t143 54q35 0 67.5 -10.5t54 -25t37.5 -29.5t24 -25l7 -11l-40 -31q-2 3 -6 8.5t-18 19.5t-30 24.5t-41.5 19.5t-53.5 9q-65 0 -104.5 -35t-39.5 -88 q0 -31 12.5 -55.5t41 -45t54 -34t71.5 -33.5q85 -37 126 -82t41 -113q0 -83 -60 -135t-149 -52q-43 0 -81.5 14.5t-62 35.5t-41 42.5t-24.5 35.5l-8 15l47 28q2 -5 6 -13t18.5 -28.5t32 -36.5t48 -29t65.5 -13q67 0 112 37t45 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 506,
    d: "M227 0v652h-211v48h474v-48h-211v-652h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 596,
    d: "M590 700l-292 -720l-292 720h56l237 -595l237 595h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 939,
    d: "M935 700l-258 -720l-207 634l-208 -634l-258 720h56l204 -572l179 572h53l182 -572l202 572h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 587,
    d: "M503 0l-210 319l-211 -319h-61l242 361l-226 339h63l194 -297l195 297h61l-226 -339l242 -361h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 568,
    d: "M258 0v275l-242 425h60l209 -372l209 372h58l-242 -425v-275h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 564,
    d: "M47 700h493l-426 -652h411v-48h-501l426 652h-403v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 308,
    d: "M137 692v-874h116v-48h-168v970h168v-48h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 485,
    d: "M423 -126l-396 899l43 19l396 -899z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 307,
    d: "M200 -182v874h-116v48h168v-970h-168v48h116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 536,
    d: "M38 350l206 406h48l206 -406h-60l-170 345l-172 -345h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 500,
    d: "M42 -230v52h416v-52h-416z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 264,
    d: "M23 657l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-56 -20.5 l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 567,
    d: "M135 0h-47v756h51v-372q56 84 165 84q97 0 162 -67.5t65 -172.5t-65 -172.5t-162 -67.5q-34 0 -63.5 9t-48 22t-32 26.5t-19.5 22.5l-6 9v-77zM140 320v-184q2 -4 5.5 -10.5t18 -23t31.5 -29.5t46.5 -23.5t62.5 -10.5q76 0 124.5 54.5t48.5 134.5t-48.5 134.5 t-124.5 54.5q-52 0 -93 -24.5t-56 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 480,
    d: "M271 39q45 0 82.5 19t52.5 38l16 19l36 -34q-3 -4 -8 -10t-22.5 -22t-37.5 -28.5t-52 -22.5t-67 -10q-101 0 -168 70t-67 170t67 170t168 70q33 0 64 -9t51.5 -21.5t36.5 -25t23 -21.5l7 -9l-37 -33q-6 8 -16.5 19t-48 30t-80.5 19q-80 0 -130.5 -55.5t-50.5 -133.5 t50.5 -133.5t130.5 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 567,
    d: "M479 0h-47v84q-2 -4 -6.5 -10.5t-20 -23t-33 -29t-47.5 -23t-62 -10.5q-97 0 -162 67.5t-65 172.5t65 172.5t162 67.5q35 0 65.5 -10.5t51 -27.5t31 -28.5t17.5 -22.5v377h51v-756zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-46.5 25.5t-61 11.5q-76 0 -124.5 -54.5 t-48.5 -134.5t48.5 -134.5t124.5 -54.5q32 0 60.5 11t46.5 26.5t31.5 31t19.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12 q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 323,
    d: "M23 408v48h98v179q0 62 37.5 97.5t87.5 35.5q45 0 87 -22l-22 -45q-27 16 -58 16q-80 0 -80 -96v-165h120v-48h-120v-408h-52v408h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 551,
    d: "M432 456h47v-467q0 -106 -61 -168.5t-162 -62.5q-38 0 -73 9.5t-58.5 23t-42 27.5t-26.5 24l-9 9l35 37q2 -3 7 -8.5t21 -19t34.5 -24t49 -19t62.5 -8.5q84 0 127.5 49t43.5 129v89q-63 -88 -165 -88q-96 0 -161 67.5t-65 172.5t65 172.5t161 67.5q34 0 63.5 -10 t48.5 -24t32.5 -28t19.5 -24l6 -10v84zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-31.5 32t-46.5 25.5t-62.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q33 0 62 11t47 26.5t31.5 31t19.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 534,
    d: "M140 381q2 4 5.5 9.5t17 20.5t29 26.5t42.5 21t57 9.5q70 0 120.5 -45t50.5 -132v-291h-52v283q0 67 -35 100.5t-94 33.5q-45 0 -80 -25.5t-48 -51.5l-13 -25v-315h-52v756h52v-375z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 224,
    d: "M86 0v456h52v-456h-52zM72 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 246,
    d: "M-22 -221l20 45q24 -15 46 -15q17 0 29 3.5t23.5 20.5t11.5 47v576h52v-584q0 -57 -32.5 -85.5t-75.5 -28.5q-19 0 -37.5 5t-27.5 11zM94 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 470,
    d: "M387 0l-247 228v-228h-52v756h52v-509l228 209h73l-237 -218l260 -238h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 228,
    d: "M88 0l2 756h50v-756h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 768,
    d: "M412 329v-329h-52v284q0 133 -111 133q-24 0 -46 -9t-35.5 -22t-24 -26t-15.5 -22l-4 -9v-329h-52v456h47v-77l5 10t15.5 21t27.5 27t40 21.5t54 9.5q100 0 138 -89q3 5 7 12t17 22t28 26t40.5 20t53.5 9q62 0 106.5 -40t44.5 -128v-300h-52v284q0 133 -111 133 q-24 0 -45.5 -9t-34.5 -22t-23 -26t-14 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 518,
    d: "M275 468q70 0 120.5 -45t50.5 -132v-291h-52v283q0 67 -35 100.5t-94 33.5q-45 0 -80 -25.5t-48 -51.5l-13 -25v-315h-52v456h47v-83q2 4 5.5 10.5t17 22.5t30 28.5t44.5 23t59 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 536,
    d: "M268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 551,
    d: "M72 456h47v-84q2 4 6.5 10.5t19.5 23t33 29t48 23t63 10.5q96 0 161 -67.5t65 -172.5t-65 -172.5t-161 -67.5q-101 0 -165 88v-306h-52v686zM124 311v-166q2 -4 6 -11.5t18.5 -25.5t32 -32t46.5 -25.5t61 -11.5q76 0 124.5 54.5t48.5 134.5t-48.5 134.5t-124.5 54.5 q-32 0 -61 -11t-47 -26.5t-31.5 -31t-18.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 551,
    d: "M432 456h47v-686h-52v306q-64 -88 -165 -88q-96 0 -161 67.5t-65 172.5t65 172.5t161 67.5q33 0 62.5 -10t48.5 -24t33 -28t20 -24l6 -10v84zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-46.5 25.5t-61 11.5q-76 0 -124.5 -54.5t-48.5 -134.5t48.5 -134.5t124.5 -54.5 q32 0 61 11t47 26.5t31.5 31t19.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 329,
    d: "M252 468q19 0 37 -3t26 -6l8 -3l-22 -50q-19 11 -61 11q-35 0 -64 -22t-40 -44l-12 -22v-329h-52v456h47v-74q2 3 5 9t15 21t26 26t37.5 20.5t49.5 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 447,
    d: "M37 85l41 35q2 -3 5.5 -8.5t17.5 -19.5t30 -24.5t43.5 -19.5t57.5 -9q45 0 82 19.5t37 60.5q0 35 -31 52t-96 32q-80 18 -121 50t-41 86q0 51 44.5 90t116.5 39q48 0 88.5 -16t57.5 -32l17 -16l-34 -38l-5.5 5.5t-16 12.5t-26.5 15.5t-36 12t-45 5.5q-47 0 -77.5 -21.5 t-30.5 -56.5q0 -20 9.5 -34.5t31 -25t41.5 -16t55 -13.5q73 -16 113 -45t40 -86q0 -62 -51.5 -96.5t-121.5 -34.5q-38 0 -72 10t-55.5 24.5t-37.5 28.5t-23 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 377,
    d: "M28 408v48h99v147h52v-147h155v-48h-155v-275q0 -94 80 -94q16 0 33 5.5t26 10.5l9 5l20 -45q-44 -27 -90 -27q-64 0 -97 37.5t-33 97.5v285h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 472,
    d: "M8 456h56l173 -367l173 367h54l-228 -476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 744,
    d: "M10 456h56l148 -357l145 357h30l144 -357l147 357h54l-204 -476l-158 381l-159 -381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 488,
    d: "M385 456h64l-174 -221l187 -235h-64l-154 198l-154 -198h-64l187 235l-174 221h64l141 -185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 489,
    d: "M31 -202l31 42q27 -31 62 -31q25 0 40.5 14.5t29.5 49.5l47 119l-227 464h56l198 -409l159 409h54q-230 -578 -241 -605q-20 -50 -48.5 -71.5t-71.5 -21.5q-21 0 -43.5 10t-34.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 465,
    d: "M59 456h372l-301 -408h290v-48h-382l301 408h-280v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 312,
    d: "M269 740v-48h-10q-34 0 -51 -14.5t-17 -57.5v-235q0 -124 -104 -128v-4q104 -4 104 -128v-235q0 -43 17 -57.5t51 -14.5h10v-48h-20q-52 0 -81 28.5t-29 85.5v241q0 61 -27 81t-73 20v58q46 0 73 20t27 81v241q0 56 33 85t77 29h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 260,
    d: "M104 -230v970h52v-970h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 312,
    d: "M43 692v48h20q44 0 77 -29t33 -85v-241q0 -61 27 -81t73 -20v-58q-46 0 -73 -20t-27 -81v-241q0 -57 -29 -85.5t-81 -28.5h-20v48h10q34 0 51 14.5t17 57.5v235q0 124 104 128v4q-104 4 -104 128v235q0 43 -17 57.5t-51 14.5h-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 409,
    d: "M67 287l-45 25q1 3 2.5 9t10 21t19.5 26t32 20.5t47 9.5q31 0 79.5 -29t65.5 -29q26 0 42 15t19 31l3 15l45 -25q-1 -3 -2.5 -9t-10 -21t-19.5 -26t-32 -20.5t-47 -9.5q-31 0 -79.5 29t-65.5 29q-26 0 -42 -15t-19 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    unicode: "\xA0",
    horizAdvX: 272
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 256,
    d: "M154 281v-519h-52v519h52zM88 434q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    d: "M291 -94v84q-90 10 -148 77.5t-58 160.5q0 92 58 160t148 78v92h43v-91q31 -2 59.5 -11t47.5 -21.5t33.5 -24.5t21.5 -20l6 -8l-37 -33q-2 2 -5.5 6.5t-16 15t-26.5 19.5t-36.5 16.5t-46.5 9.5v-377q40 3 74.5 22t48.5 37l14 17l36 -34q-2 -3 -7 -9t-21 -21t-34.5 -27 t-48.5 -22.5t-62 -12.5v-83h-43zM139 228q0 -71 42 -124t110 -63v374q-68 -10 -110 -63.5t-42 -123.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M155 524q0 -32 13.5 -64t51.5 -96h192v-48h-165q32 -50 32 -108q0 -30 -8.5 -55.5t-17.5 -35.5l-9 -10q23 -5 70.5 -36.5t82.5 -31.5q30 0 51 16.5t26 32.5l6 17l44 -22q-1 -4 -3.5 -10.5t-13 -22.5t-23.5 -28.5t-37 -23t-53 -10.5q-37 0 -69.5 17.5t-60.5 35t-55 17.5 q-31 0 -51.5 -17.5t-25.5 -34.5l-6 -18l-47 25l3 9t10.5 21t19 27.5t29 24.5t40.5 16q5 3 12.5 10.5t19.5 33t12 55.5q0 20 -9.5 46.5t-19.5 43.5l-10 16h-108v48h82q-31 55 -45 90t-14 70q0 71 53 129.5t149 58.5q34 0 66 -10t52.5 -25t36 -29.5t22.5 -24.5l7 -10l-40 -30 q-2 3 -5.5 8.5t-17 19t-29 23.5t-40.5 18.5t-52 8.5q-76 0 -112 -43.5t-36 -93.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 562,
    d: "M70 572l67 -67q63 50 144 50q79 0 144 -50l67 67l38 -38l-67 -67q50 -65 50 -144q0 -81 -50 -144l67 -67l-38 -38l-67 67q-63 -50 -144 -50q-83 0 -144 50l-67 -67l-38 38l67 67q-50 61 -50 144q0 81 50 144l-67 67zM99 322q0 -76 53 -129t129 -53t129.5 53t53.5 129 t-53.5 129.5t-129.5 53.5t-129 -53.5t-53 -129.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    d: "M264 0v270h-229v47h205l-38 66h-167v47h141l-154 270h62l209 -371l207 371h58l-154 -270h141v-47h-167l-38 -66h205v-47h-229v-270h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 260,
    d: "M104 350v390h52v-390h-52zM104 -230v390h52v-390h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 508,
    d: "M434 248q0 -52 -36.5 -87.5t-85.5 -46.5q113 -65 113 -155q0 -64 -51.5 -108.5t-126.5 -44.5q-46 0 -87 20.5t-59 41.5l-18 20l41 32q2 -3 5 -7t14.5 -15t24.5 -19t34.5 -15t44.5 -7q62 0 93 31.5t31 70.5q0 21 -7.5 39t-16.5 29.5t-29 25t-31.5 19.5t-38.5 19t-36 18 q-31 16 -44.5 23t-36.5 23t-32.5 30t-18 36t-8.5 49q0 52 36.5 87t85.5 47q-113 63 -113 155q0 64 51.5 108.5t126.5 44.5q46 0 87 -20.5t59 -41.5l18 -20l-41 -32q-2 3 -5 7t-14.5 15t-24.5 19t-34.5 15t-44.5 7q-62 0 -93 -31.5t-31 -70.5q0 -21 7.5 -39t16.5 -29.5 t29 -25t31.5 -19.5t38.5 -19t36 -18q31 -16 44.5 -23t36.5 -23t32.5 -30t18 -36t8.5 -49zM250 376h-2q-44 -3 -84.5 -29t-40.5 -77q0 -18 6 -33t12 -24.5t23.5 -21.5t25 -16t33.5 -16.5t33 -16.5q19 2 39 8t41 17.5t34 32.5t13 48q0 15 -3 28t-12 24t-15.5 18t-22 16.5 t-23.5 14t-28.5 14t-28.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 391,
    d: "M65 604q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28zM246 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 820,
    d: "M50 350q0 150 105.5 256t254.5 106t254.5 -106t105.5 -256t-105.5 -256t-254.5 -106t-254.5 106t-105.5 256zM93 349q0 -130 91 -224.5t226 -94.5t226 94.5t91 224.5q0 135 -90 228t-227 93t-227 -93t-90 -228zM421 194q37 0 68 15t43 31l13 15l31 -29q-2 -3 -6 -8.5 t-18.5 -18.5t-31 -23t-43.5 -18.5t-56 -8.5q-83 0 -138.5 58t-55.5 141t55.5 141t138.5 58q44 0 81.5 -17.5t53.5 -35.5l15 -17l-33 -29q-4 6 -12.5 15t-38.5 24t-66 15q-66 0 -107.5 -44.5t-41.5 -109.5t41.5 -109.5t107.5 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 306,
    d: "M148 712q57 0 87 -29t30 -71v-181h-44v40q-3 -5 -10 -13t-30.5 -21t-51.5 -13q-39 0 -69 25t-30 67q0 40 30 66.5t76 26.5q22 0 42.5 -6.5t29.5 -12.5l9 -7v19q0 26 -14.5 41.5t-28.5 19t-29 3.5q-18 0 -38 -6t-31 -12l-10 -5l-20 41q41 28 102 28zM140 468q21 0 40.5 10 t27.5 20l9 11v35q-26 23 -71 23q-31 0 -49.5 -14.5t-18.5 -36.5q0 -24 18.5 -36t43.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 454,
    d: "M22 245l172 224l40 -32l-149 -192l149 -192l-40 -32zM172 245l172 224l40 -32l-149 -192l149 -192l-40 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 674,
    d: "M18 437v48h590v-285h-50v237h-540z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "softhyphen",
    unicode: "\xAD",
    horizAdvX: 333,
    d: "M33 213v48h267v-48h-267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 405,
    d: "M22 531q0 75 53 128t128 53t127.5 -53t52.5 -128t-52.5 -128t-127.5 -53t-128 53t-53 128zM147 439v188h61q28 0 45.5 -16t17.5 -42q0 -45 -43 -56l49 -74h-38l-46 71h-14v-71h-32zM179 540h26q36 0 36 29t-36 29h-26v-58zM59 531q0 -60 42 -102t102 -42t102.5 42 t42.5 102t-42.5 102.5t-102.5 42.5t-102 -42.5t-42 -102.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 314,
    d: "M6 583v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 332,
    d: "M310 568q0 -59 -42.5 -101.5t-101.5 -42.5t-101.5 42.5t-42.5 101.5t42.5 101.5t101.5 42.5t101.5 -42.5t42.5 -101.5zM68 568q0 -40 28.5 -68.5t69.5 -28.5t69.5 28.5t28.5 68.5t-29 69t-69 29t-69 -29t-29 -69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 520,
    d: "M45 0v48h430v-48h-430zM45 262v48h190v164h50v-164h190v-48h-190v-170h-50v170h-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 351,
    d: "M240 559l-111 -125h176v-40h-272l165 181q1 2 7.5 9t8.5 9t8 9t8 10t6.5 9.5t6.5 10.5t5 10.5t4.5 11.5t2.5 11t1 12q0 35 -23 61t-68 26q-66 0 -93 -72l-39 16q14 43 48 70.5t84 27.5q60 0 97.5 -35.5t37.5 -93.5q0 -30 -14.5 -56t-45.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 358,
    d: "M261 691q0 30 -20 51.5t-62 21.5q-29 0 -50.5 -14.5t-28.5 -29.5l-7 -14l-36 18q1 3 4 8.5t13 20t22.5 25t35 19.5t47.5 9q57 0 91.5 -32.5t34.5 -82.5q0 -28 -14.5 -50t-28.5 -30l-15 -8q3 -1 7 -2.5t15 -8.5t19 -17t15 -28.5t7 -42.5q0 -52 -40.5 -84t-93.5 -32 q-48 0 -81 24t-43 48l-9 24l38 17l2.5 -7.5t8.5 -17t16.5 -22t27.5 -17t40 -7.5q41 0 65.5 21.5t24.5 52.5q0 35 -24 56.5t-63 21.5h-23v39h23q35 0 58.5 18.5t23.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 264,
    d: "M202 694l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 528,
    d: "M247 -12q-74 0 -119 48v-266h-52v686h52v-273q0 -144 134 -144q25 0 48.5 9.5t38.5 22.5t26.5 26t16.5 23l6 9v327h52v-456h-47v76q-2 -4 -5.5 -9.5t-17.5 -21t-30.5 -27t-44 -21t-58.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    horizAdvX: 528,
    d: "M247 -12q-74 0 -119 48v-266h-52v686h52v-273q0 -144 134 -144q25 0 48.5 9.5t38.5 22.5t26.5 26t16.5 23l6 9v327h52v-456h-47v76q-2 -4 -5.5 -9.5t-17.5 -21t-30.5 -27t-44 -21t-58.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 568,
    d: "M354 652v-840h-52v414q-98 0 -168 69t-70 167t70 168t168 70h174v-888h-52v840h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 212,
    d: "M66 350q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 315,
    d: "M213 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 276,
    d: "M14 682l142 118h34v-406h-42v345l-108 -89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 324,
    d: "M306 568q0 -59 -42.5 -101.5t-101.5 -42.5t-101.5 42.5t-42.5 101.5t42.5 101.5t101.5 42.5t101.5 -42.5t42.5 -101.5zM258 568q0 40 -28.5 68.5t-68.5 28.5t-67.5 -28.5t-27.5 -68.5t28 -68.5t68 -28.5t68 28.5t28 68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 454,
    d: "M270 469l172 -224l-172 -224l-40 32l149 192l-149 192zM120 469l172 -224l-172 -224l-40 32l149 192l-149 192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 830,
    d: "M180 -3l475 730l35 -24l-475 -730zM473 93l217 313h36v-273h54v-40h-54v-93h-42v93h-211zM547 133h137v200zM51 582l142 118h34v-406h-42v345l-108 -89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 830,
    d: "M694 165l-111 -125h176v-40h-272l165 181q1 2 7.5 9t8.5 9t8 9t8 10t6.5 9.5t6.5 10.5t5 10.5t4.5 11.5t2.5 11t1 12q0 35 -23 61t-68 26q-66 0 -93 -72l-39 16q14 43 48 70.5t84 27.5q60 0 97.5 -35.5t37.5 -93.5q0 -30 -14.5 -56t-45.5 -62zM140 -3l475 730l35 -24 l-475 -730zM51 582l142 118h34v-406h-42v345l-108 -89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 830,
    d: "M199 -3l475 730l35 -24l-475 -730zM262 591q0 30 -20 51.5t-62 21.5q-29 0 -50.5 -14.5t-28.5 -29.5l-7 -14l-36 18q1 3 4 8.5t13 20t22.5 25t35 19.5t47.5 9q57 0 91.5 -32.5t34.5 -82.5q0 -28 -14.5 -50t-29.5 -30l-14 -8q3 -1 7 -2.5t15 -8.5t19 -17t15 -28.5t7 -42.5 q0 -52 -40.5 -84t-93.5 -32q-30 0 -55 10t-39 24t-23.5 28t-12.5 24l-3 10l38 17l2.5 -7.5t8.5 -17t16.5 -22t27.5 -17t40 -7.5q41 0 65.5 21.5t24.5 52.5q0 35 -24 56.5t-63 21.5h-23v39h23q35 0 58.5 18.5t23.5 51.5zM474 93l217 313h36v-273h54v-40h-54v-93h-42v93h-211z M548 133h137v200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 478,
    d: "M106 -67q0 -58 38 -95t105 -37q36 0 64 11t43.5 27.5t25.5 32.5t13 27l3 11l49 -16q-1 -6 -4.5 -15.5t-18 -34.5t-34.5 -44t-57.5 -34.5t-83.5 -15.5q-82 0 -139.5 51t-57.5 132q0 39 17.5 73.5t35.5 52t53.5 45.5t47.5 40q10 10 11.5 17t1.5 32v89h52v-90 q0 -40 -5 -54.5t-28 -33.5l-40.5 -31.5t-39.5 -32.5t-25 -27.5t-22 -38t-5 -41.5zM285 434q0 -16 -11.5 -28t-28.5 -12t-28.5 12t-11.5 28t11.5 28t28.5 12t28.5 -12t11.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304zM183 895l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304zM419 932l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304zM160 792l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304zM211 783l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22 t-55 22q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304zM190 842q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM371 842q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304zM221 840q0 41 29 70t70 29t70 -29t29 -70t-29 -70t-70 -29t-70 29t-29 70zM262 840q0 -25 16.5 -41.5t41.5 -16.5t42 16.5t17 41.5t-17 42t-42 17t-41.5 -17t-16.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 865,
    d: "M503 652v-269h276v-48h-276v-287h306v-48h-358v204h-263l-119 -204h-57l408 700h383v-48h-300zM216 252h235v404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 673,
    d: "M397 -55l-58 -194l-52 15l59 185zM390 39q68 0 126 27.5t97 73.5l36 -36q-100 -116 -259 -116q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5t249 -107l-37 -34q-82 90 -212 90q-128 0 -210 -90t-82 -221t82 -221t210 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM176 901l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM335 938l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM125 804l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM153 842q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28zM334 842q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52zM15 895l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52zM202 932l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52zM-32 762l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52zM-2 842q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM179 842q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 678,
    d: "M24 335v48h73v317h191q151 0 248.5 -99t97.5 -251t-97.5 -251t-248.5 -99h-191v335h-73zM149 48h129q137 0 219.5 83t82.5 219t-82.5 219t-219.5 83h-129v-269h211v-48h-211v-287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 710,
    d: "M88 700h52l430 -610v610h52v-700h-52l-430 612v-612h-52v700zM242 803l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22 q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 780,
    d: "M390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5t-210.5 89.5zM276 905l39 37l149 -149l-35 -33 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 780,
    d: "M463 942l35 -35l-150 -147l-34 33zM390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5 t-210.5 89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 780,
    d: "M390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5t-210.5 89.5zM230 802l160 115l160 -115 l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 780,
    d: "M390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5t-210.5 89.5zM278 783l-42 25q1 3 2.5 8 t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 780,
    d: "M390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5t-210.5 89.5zM260 842q0 16 12 28t28 12 t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM441 842q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 520,
    d: "M49 432l34 34l177 -177l177 177l34 -34l-177 -177l177 -177l-34 -34l-177 177l-177 -177l-34 34l177 177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 788,
    d: "M394 -12q-120 0 -209 69l-68 -81l-35 30l69 82q-103 105 -103 262q0 153 99 257.5t247 104.5q124 0 216 -76l73 87l35 -30l-74 -89q96 -104 96 -254q0 -153 -98.5 -257.5t-247.5 -104.5zM394 661q-129 0 -210.5 -89.5t-81.5 -221.5q0 -134 82 -222l393 469 q-77 64 -183 64zM394 39q129 0 210.5 89.5t81.5 221.5q0 125 -76 214l-392 -467q74 -58 176 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM203 901l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM433 938l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM177 802l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM207 842q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28zM388 842q0 16 12 28t28 12t28 -12 t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 568,
    d: "M258 0v275l-242 425h60l209 -372l209 372h58l-242 -425v-275h-52zM391 938l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 538,
    d: "M88 0v700h52v-127h133q105 0 167 -51t62 -147t-62 -147t-167 -51h-133v-177h-52zM140 225h129q79 0 129 34.5t50 115.5t-50 115.5t-129 34.5h-129v-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 586,
    d: "M88 0v556q0 95 54.5 153.5t141.5 58.5q33 0 66 -9.5t63.5 -30t49.5 -58.5t19 -89q0 -33 -10 -60.5t-25 -43t-29.5 -27t-24.5 -15.5l-10 -4q6 -1 16.5 -4.5t36.5 -18.5t45.5 -36.5t36 -62t16.5 -90.5q0 -63 -21.5 -109.5t-58 -72t-79.5 -37.5t-92 -12h-30v48h25 q204 0 204 183q0 77 -48.5 130t-144.5 53v46q41 0 70.5 13.5t44 35t20.5 42.5t6 43q0 57 -36.5 96t-109.5 39q-70 0 -107 -47.5t-37 -119.5v-550h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-56 -20.5 l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5zM160 675l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 505,
    d: "M336 712l35 -35l-150 -147l-34 33zM246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18 t-42.5 5q-37 0 -74 -10.5t-56 -20.5l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-56 -20.5 l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5zM92 577l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-56 -20.5 l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5zM141 568l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12t16.5 24l3 13 l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12.5t-16.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-56 -20.5 l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5zM130 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM311 604q0 16 11.5 28 t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-56 -20.5 l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5zM166 641q0 41 29 70t70 29t70 -29t29 -70t-29 -70t-70 -29t-70 29t-29 70zM207 641q0 -25 16.5 -41.5 t41.5 -16.5t42 16.5t17 41.5t-17 42t-42 17t-41.5 -17t-16.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 853,
    d: "M599 468q92 0 155 -66.5t63 -170.5q0 -10 -1 -21h-390q4 -62 51.5 -116.5t130.5 -54.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-68 0 -121.5 32t-83.5 87q-64 -119 -197 -119q-64 0 -111 38.5t-47 98.5q0 63 46.5 98t135.5 35h144v21q0 64 -39 101t-101 37 q-36 0 -70.5 -9.5t-51.5 -19.5l-17 -10l-24 45q8 5 22 12.5t56.5 20t84.5 12.5q64 0 110 -29.5t64 -74.5v-5q29 50 78.5 79.5t112.5 29.5zM428 258h335q-1 22 -10 47t-27 51.5t-51.5 43.5t-75.5 17q-45 0 -79.5 -17.5t-53 -44t-28 -51.5t-10.5 -46zM221 39q67 0 110 46 t43 87v38q-57 1 -139 1q-67 0 -100 -19.5t-33 -66.5q0 -44 34 -65t85 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 480,
    d: "M271 39q45 0 82.5 19t52.5 38l16 19l36 -34q-3 -4 -8 -10t-22.5 -22t-37.5 -28.5t-52 -22.5t-67 -10q-101 0 -168 70t-67 170t67 170t168 70q33 0 64 -9t51.5 -21.5t36.5 -25t23 -21.5l7 -9l-37 -33q-6 8 -16.5 19t-48 30t-80.5 19q-80 0 -130.5 -55.5t-50.5 -133.5 t50.5 -133.5t130.5 -55.5zM274 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12 q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5zM159 675l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 518,
    d: "M333 712l35 -35l-150 -147l-34 33zM261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5 t-31.5 40.5t-47.5 30t-63 12q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12 q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5zM110 567l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12 q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5zM134 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM315 604q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 224,
    d: "M0 675l39 37l149 -149l-35 -33zM86 0v456h52v-456h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 224,
    d: "M185 712l35 -35l-150 -147l-34 33zM84 0v456h52v-456h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 256,
    d: "M102 0v456h52v-456h-52zM-32 567l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 245,
    d: "M-8 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM173 604q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28zM96 0v456h52v-456h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 544,
    d: "M426 682l-106 -49q79 -69 129.5 -163t50.5 -208v-14q0 -118 -64.5 -189t-167.5 -71q-101 0 -166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5q99 0 153 -62q-42 114 -152 204l-136 -63l-19 40l115 53q-32 24 -66 44.5t-51 29.5l-18 8l22 43q79 -34 165 -100l126 58z M268 39q81 0 129.5 57t48.5 132q0 81 -47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 522,
    d: "M275 468q70 0 120.5 -45t50.5 -132v-291h-52v283q0 67 -35 100.5t-94 33.5q-45 0 -80 -25.5t-48 -51.5l-13 -25v-315h-52v456h47v-83q2 4 5.5 10.5t17 22.5t30 28.5t44.5 23t59 10.5zM147 555l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22 q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 536,
    d: "M268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54zM163 675l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 536,
    d: "M334 712l35 -35l-150 -147l-34 33zM268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 536,
    d: "M268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54zM108 567l160 115l160 -115l-30 -37l-130 96 l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 536,
    d: "M268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54zM157 568l-42 25q1 3 2.5 8t9 17.5t17.5 22 t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12t16.5 24l3 13l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12.5t-16.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 536,
    d: "M268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54zM138 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28 t-28 -12t-28 12t-12 28zM319 604q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 520,
    d: "M45 227v48h430v-48h-430zM220 428q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM220 78q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 544,
    d: "M61 15l40 48q-61 67 -61 165q0 101 65.5 170.5t166.5 69.5q76 0 134 -42l44 53l35 -30l-45 -53q64 -70 64 -168q0 -101 -65.5 -170.5t-166.5 -69.5q-79 0 -137 44l-39 -47zM272 39q83 0 130.5 54t47.5 135q0 76 -43 128l-240 -286q42 -31 105 -31zM94 228q0 -74 40 -126 l239 286q-44 29 -101 29q-83 0 -130.5 -54t-47.5 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10zM127 675l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 518,
    d: "M353 712l35 -35l-150 -147l-34 33zM243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10zM102 567l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10zM130 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM311 604 q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 489,
    d: "M348 712l35 -35l-150 -147l-34 33zM31 -202l31 42q27 -31 62 -31q25 0 40.5 14.5t29.5 49.5l47 119l-227 464h56l198 -409l159 409h54q-230 -578 -241 -605q-20 -50 -48.5 -71.5t-71.5 -21.5q-21 0 -43.5 10t-34.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 567,
    d: "M88 -230v931h52v-319q12 17 28 33t54.5 34.5t82.5 18.5q96 0 161 -67.5t65 -172.5t-65 -172.5t-161 -67.5q-45 0 -84 18.5t-55 34.5t-26 32v-303h-52zM140 318v-180q2 -4 6 -10.5t18.5 -24t31.5 -30.5t46.5 -23.5t62.5 -10.5q76 0 124 54t48 135t-48 135t-124 54 q-33 0 -62 -10t-47 -24.5t-31.5 -29.5t-18.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 489,
    d: "M31 -202l31 42q27 -31 62 -31q25 0 40.5 14.5t29.5 49.5l47 119l-227 464h56l198 -409l159 409h54q-230 -578 -241 -605q-20 -50 -48.5 -71.5t-71.5 -21.5q-21 0 -43.5 10t-34.5 20zM118 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM299 604 q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304zM169 801v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-56 -20.5 l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5zM113 583v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700h-56l-80 204h-344l-80 -204h-56zM320 642l-152 -390h304zM183 908h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5 t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-47v79q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-56 -20.5 l-19 -11l-23 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5zM120 700h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50 q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 640,
    d: "M12 0l279 700h58l279 -700q-10 -2 -25 -7t-39.5 -25.5t-24.5 -48.5q0 -21 12 -34t34 -13l34 6v-47q-17 -6 -39 -6q-37 0 -62 24.5t-25 61.5q0 30 18.5 54.5t32.5 32.5t24 12l-76 194h-344l-80 -204h-56zM320 642l-152 -390h304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 505,
    d: "M246 468q91 0 139 -47.5t48 -121.5v-299h-1q-5 -1 -14.5 -5t-26 -13t-27.5 -26t-11 -37q0 -21 12 -34t34 -13l34 6v-47q-17 -6 -39 -6q-37 0 -62 24.5t-25 61.5q0 33 19.5 58.5t39.5 34.5l20 10v65q-2 -4 -7 -10t-21.5 -21.5t-35 -27.5t-48 -22t-60.5 -10 q-64 0 -115 41.5t-51 112.5t54.5 112.5t126.5 41.5q41 0 79 -11t56 -21l17 -11v34q0 39 -13.5 66.5t-35.5 40.5t-42.5 18t-42.5 5q-37 0 -74 -10.5t-55 -20.5l-19 -11l-24 45q8 5 23.5 13t60 21.5t87.5 13.5zM226 39q28 0 54.5 9.5t44 23t30.5 27t19 23.5l7 9v77 q-54 38 -145 38q-51 0 -92.5 -27t-41.5 -77t37 -76.5t87 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 673,
    d: "M390 39q68 0 126 27.5t97 73.5l36 -36q-100 -116 -259 -116q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5t249 -107l-37 -34q-82 90 -212 90q-128 0 -210 -90t-82 -221t82 -221t210 -90zM430 938l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 480,
    d: "M271 39q45 0 82.5 19t52.5 38l16 19l36 -34q-3 -4 -8 -10t-22.5 -22t-37.5 -28.5t-52 -22.5t-67 -10q-101 0 -168 70t-67 170t67 170t168 70q33 0 64 -9t51.5 -21.5t36.5 -25t23 -21.5l7 -9l-37 -33q-6 8 -16.5 19t-48 30t-80.5 19q-80 0 -130.5 -55.5t-50.5 -133.5 t50.5 -133.5t130.5 -55.5zM321 712l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 673,
    d: "M390 39q68 0 126 27.5t97 73.5l36 -36q-100 -116 -259 -116q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5t249 -107l-37 -34q-82 90 -212 90q-128 0 -210 -90t-82 -221t82 -221t210 -90zM223 802l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 480,
    d: "M271 39q45 0 82.5 19t52.5 38l16 19l36 -34q-3 -4 -8 -10t-22.5 -22t-37.5 -28.5t-52 -22.5t-67 -10q-101 0 -168 70t-67 170t67 170t168 70q33 0 64 -9t51.5 -21.5t36.5 -25t23 -21.5l7 -9l-37 -33q-6 8 -16.5 19t-48 30t-80.5 19q-80 0 -130.5 -55.5t-50.5 -133.5 t50.5 -133.5t130.5 -55.5zM111 567l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 673,
    d: "M390 39q68 0 126 27.5t97 73.5l36 -36q-100 -116 -259 -116q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5t249 -107l-37 -34q-82 90 -212 90q-128 0 -210 -90t-82 -221t82 -221t210 -90zM350 828q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5 t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 480,
    d: "M271 39q45 0 82.5 19t52.5 38l16 19l36 -34q-3 -4 -8 -10t-22.5 -22t-37.5 -28.5t-52 -22.5t-67 -10q-101 0 -168 70t-67 170t67 170t168 70q33 0 64 -9t51.5 -21.5t36.5 -25t23 -21.5l7 -9l-37 -33q-6 8 -16.5 19t-48 30t-80.5 19q-80 0 -130.5 -55.5t-50.5 -133.5 t50.5 -133.5t130.5 -55.5zM226 603q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 673,
    d: "M390 39q68 0 126 27.5t97 73.5l36 -36q-100 -116 -259 -116q-150 0 -248 104.5t-98 257.5t98 257.5t248 104.5t249 -107l-37 -34q-82 90 -212 90q-128 0 -210 -90t-82 -221t82 -221t210 -90zM388 756l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 480,
    d: "M271 39q45 0 82.5 19t52.5 38l16 19l36 -34q-3 -4 -8 -10t-22.5 -22t-37.5 -28.5t-52 -22.5t-67 -10q-101 0 -168 70t-67 170t67 170t168 70q33 0 64 -9t51.5 -21.5t36.5 -25t23 -21.5l7 -9l-37 -33q-6 8 -16.5 19t-48 30t-80.5 19q-80 0 -130.5 -55.5t-50.5 -133.5 t50.5 -133.5t130.5 -55.5zM266 529l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 669,
    d: "M88 700h191q151 0 248.5 -99t97.5 -251t-97.5 -251t-248.5 -99h-191v700zM140 48h129q137 0 219.5 83t82.5 219t-82.5 219t-219.5 83h-129v-604zM310 759l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 633,
    d: "M559 462v238h50v-238h-50zM479 0h-47v77q-2 -4 -6 -10t-19 -21t-32.5 -27t-47.5 -21.5t-64 -9.5q-97 0 -162 67.5t-65 172.5t65 172.5t162 67.5q109 0 165 -84v372h51v-756zM427 136v184q-2 4 -5.5 10.5t-18 23t-31.5 29.5t-46.5 23.5t-62.5 10.5q-76 0 -124.5 -54.5 t-48.5 -134.5t48.5 -134.5t124.5 -54.5q52 0 93 24.5t56 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 678,
    d: "M24 335v48h73v317h191q151 0 248.5 -99t97.5 -251t-97.5 -251t-248.5 -99h-191v335h-73zM149 48h129q137 0 219.5 83t82.5 219t-82.5 219t-219.5 83h-129v-269h211v-48h-211v-287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 591,
    d: "M479 0h-47v86q-2 -4 -6.5 -10.5t-20 -23.5t-33.5 -30t-47.5 -23.5t-61.5 -10.5q-97 0 -162 67.5t-65 172.5t65 172.5t162 67.5q34 0 64.5 -11t51 -28.5t31.5 -29t18 -22.5v200h-165v48h165v131h51v-131h80v-48h-80v-577zM427 146v164q-2 4 -6 11.5t-18.5 26t-32 32.5 t-46.5 25.5t-61 11.5q-76 0 -124.5 -54.5t-48.5 -134.5t48.5 -134.5t124.5 -54.5q32 0 60.5 11t46.5 26.5t31.5 31.5t19.5 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM133 801v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12 q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5zM110 583v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM140 898h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12 q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5zM124 700h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM242 828q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12 q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5zM223 603q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM435 0h47q-9 -4 -22.5 -11t-35.5 -28.5t-22 -42.5t12 -33.5t34 -12.5l34 6v-47q-17 -6 -39 -6q-37 0 -62 24t-25 61q0 30 20 52.5t40 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-48 -59 -122 -82q-11 -5 -26 -14t-33 -28.5t-18 -38.5q0 -21 12 -33.5t34 -12.5l34 6v-47q-17 -6 -39 -6q-37 0 -62 24t-25 61q0 49 52 78q-100 1 -166 71 t-66 169q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 538,
    d: "M140 652v-269h312v-48h-312v-287h342v-48h-394v700h388v-48h-336zM290 759l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 518,
    d: "M261 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-100 0 -167 70.5t-67 169.5q0 100 63 170t162 70zM90 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12 q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5zM267 539l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 724,
    d: "M422 319v49h242v-286q-4 -4 -11.5 -10t-34 -22.5t-56 -29t-76.5 -22.5t-97 -10q-153 0 -249 104t-96 258q0 153 97.5 257.5t247.5 104.5q77 0 140.5 -25t88.5 -49l25 -25l-37 -35q-3 3 -8.5 9t-25 20t-42.5 25t-61 20t-80 9q-127 0 -209 -89.5t-82 -221.5q0 -133 80 -222 t211 -89q67 0 123 16.5t78 32.5l23 17v214h-191zM222 802l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 551,
    d: "M432 456h47v-467q0 -106 -61 -168.5t-162 -62.5q-38 0 -73 9.5t-58.5 23t-42 27.5t-26.5 24l-9 9l35 37q2 -3 7 -8.5t21 -19t34.5 -24t49 -19t62.5 -8.5q84 0 127.5 49t43.5 129v89q-63 -88 -165 -88q-96 0 -161 67.5t-65 172.5t65 172.5t161 67.5q34 0 63.5 -10 t48.5 -24t32.5 -28t19.5 -24l6 -10v84zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-31.5 32t-46.5 25.5t-62.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q33 0 62 11t47 26.5t31.5 31t19.5 26.5zM108 567l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 724,
    d: "M422 319v49h242v-286q-4 -4 -11.5 -10t-34 -22.5t-56 -29t-76.5 -22.5t-97 -10q-153 0 -249 104t-96 258q0 153 97.5 257.5t247.5 104.5q77 0 140.5 -25t88.5 -49l25 -25l-37 -35q-3 3 -8.5 9t-25 20t-42.5 25t-61 20t-80 9q-127 0 -209 -89.5t-82 -221.5q0 -133 80 -222 t211 -89q67 0 123 16.5t78 32.5l23 17v214h-191zM258 908h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 551,
    d: "M432 456h47v-467q0 -106 -61 -168.5t-162 -62.5q-38 0 -73 9.5t-58.5 23t-42 27.5t-26.5 24l-9 9l35 37q2 -3 7 -8.5t21 -19t34.5 -24t49 -19t62.5 -8.5q84 0 127.5 49t43.5 129v89q-63 -88 -165 -88q-96 0 -161 67.5t-65 172.5t65 172.5t161 67.5q34 0 63.5 -10 t48.5 -24t32.5 -28t19.5 -24l6 -10v84zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-31.5 32t-46.5 25.5t-62.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q33 0 62 11t47 26.5t31.5 31t19.5 26.5zM131 700h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22 t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 724,
    d: "M422 319v49h242v-286q-4 -4 -11.5 -10t-34 -22.5t-56 -29t-76.5 -22.5t-97 -10q-153 0 -249 104t-96 258q0 153 97.5 257.5t247.5 104.5q77 0 140.5 -25t88.5 -49l25 -25l-37 -35q-3 3 -8.5 9t-25 20t-42.5 25t-61 20t-80 9q-127 0 -209 -89.5t-82 -221.5q0 -133 80 -222 t211 -89q67 0 123 16.5t78 32.5l23 17v214h-191zM353 828q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 551,
    d: "M432 456h47v-467q0 -106 -61 -168.5t-162 -62.5q-38 0 -73 9.5t-58.5 23t-42 27.5t-26.5 24l-9 9l35 37q2 -3 7 -8.5t21 -19t34.5 -24t49 -19t62.5 -8.5q84 0 127.5 49t43.5 129v89q-63 -88 -165 -88q-96 0 -161 67.5t-65 172.5t65 172.5t161 67.5q34 0 63.5 -10 t48.5 -24t32.5 -28t19.5 -24l6 -10v84zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-31.5 32t-46.5 25.5t-62.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q33 0 62 11t47 26.5t31.5 31t19.5 26.5zM240 603q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5 t-28.5 11.5t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcedilla",
    unicode: "\u0122",
    horizAdvX: 724,
    d: "M422 319v49h242v-286q-4 -4 -11.5 -10t-34 -22.5t-56 -29t-76.5 -22.5t-97 -10q-153 0 -249 104t-96 258q0 153 97.5 257.5t247.5 104.5q77 0 140.5 -25t88.5 -49l25 -25l-37 -35q-3 3 -8.5 9t-25 20t-42.5 25t-61 20t-80 9q-127 0 -209 -89.5t-82 -221.5q0 -133 80 -222 t211 -89q67 0 123 16.5t78 32.5l23 17v214h-191zM409 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcedilla",
    unicode: "\u0123",
    horizAdvX: 551,
    d: "M432 456h47v-467q0 -106 -61 -168.5t-162 -62.5q-38 0 -73 9.5t-58.5 23t-42 27.5t-26.5 24l-9 9l35 37q2 -3 7 -8.5t21 -19t34.5 -24t49 -19t62.5 -8.5q84 0 127.5 49t43.5 129v89q-63 -88 -165 -88q-96 0 -161 67.5t-65 172.5t65 172.5t161 67.5q34 0 63.5 -10 t48.5 -24t32.5 -28t19.5 -24l6 -10v84zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-31.5 32t-46.5 25.5t-62.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q33 0 62 11t47 26.5t31.5 31t19.5 26.5zM229 532l58 194l52 -15l-59 -185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 683,
    d: "M543 383v317h52v-700h-52v335h-403v-335h-52v700h52v-317h403zM182 802l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 534,
    d: "M140 381q2 4 5.5 9.5t17 20.5t29 26.5t42.5 21t57 9.5q70 0 120.5 -45t50.5 -132v-291h-52v283q0 67 -35 100.5t-94 33.5q-45 0 -80 -25.5t-48 -51.5l-13 -25v-315h-52v756h52v-375zM-43 822l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 693,
    d: "M667 555v-48h-67v-507h-52v335h-403v-335h-52v507h-67v48h67v145h52v-145h403v145h52v-145h67zM548 383v124h-403v-124h403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 540,
    d: "M297 468q71 0 121 -44t50 -133v-291h-52v273q0 144 -134 144q-25 0 -48.5 -9.5t-38.5 -22.5t-26.5 -26t-16.5 -23l-6 -9v-327h-52v577h-82v48h82v131h52v-131h147v-48h-147v-188q53 79 151 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52zM16 793l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 248,
    d: "M98 0v456h52v-456h-52zM12 555l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52zM-23 821v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 231,
    d: "M93 0v456h52v-456h-52zM-29 583v48h296v-48h-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52zM-9 908h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 230,
    d: "M89 0v456h52v-456h-52zM-22 680h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 256,
    d: "M154 0h-1q-5 -1 -14.5 -5t-25.5 -13t-27 -26t-11 -37q0 -21 12 -34t34 -13l34 6v-47q-17 -6 -39 -6q-37 0 -62 24.5t-25 61.5q0 28 16 52.5t30 34.5t27 16v686h52v-700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 224,
    d: "M12 -89q0 29 16 52.5t30.5 32.5t27.5 15v445h52v-456h-1q-5 -1 -14.5 -5t-26 -13t-27.5 -26t-11 -37q0 -21 12 -34t34 -13l34 6v-47q-17 -6 -39 -6q-37 0 -62 24.5t-25 61.5zM72 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 256,
    d: "M102 0v700h52v-700h-52zM88 838q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 224,
    d: "M86 0v456h52v-456h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 680,
    d: "M102 0v700h52v-700h-52zM540 190v510h52v-510q0 -96 -50.5 -149t-135.5 -53q-33 0 -63.5 10.5t-50.5 25t-35.5 29.5t-22.5 25l-7 11l40 33q2 -3 5.5 -9t16.5 -20t27.5 -25t39 -20t50.5 -9q68 0 101 42.5t33 108.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 421,
    d: "M86 0v456h52v-456h-52zM72 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM153 -221l20 45q24 -15 46 -15q17 0 29 3.5t23.5 20.5t11.5 47v576h52v-584q0 -57 -32.5 -85.5t-75.5 -28.5q-19 0 -37.5 5t-27.5 11zM269 604q0 16 11.5 28t28.5 12 t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 501,
    d: "M326 190v510h52v-510q0 -96 -50.5 -149t-135.5 -53q-33 0 -63.5 10.5t-50.5 25t-35.5 29.5t-22.5 25l-7 11l40 33q2 -3 5.5 -9t16.5 -20t27.5 -25t39 -20t50.5 -9q68 0 101 42.5t33 108.5zM193 792l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 246,
    d: "M-22 -221l20 45q24 -15 46 -15q17 0 29 3.5t23.5 20.5t11.5 47v576h52v-584q0 -57 -32.5 -85.5t-75.5 -28.5q-19 0 -37.5 5t-27.5 11zM-26 552l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcedilla",
    unicode: "\u0136",
    horizAdvX: 569,
    d: "M140 700v-337l311 337h68l-317 -343l367 -357h-75l-354 343v-343h-52v700h52zM333 -36l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcedilla",
    unicode: "\u0137",
    horizAdvX: 470,
    d: "M387 0l-247 228v-228h-52v756h52v-509l228 209h73l-237 -218l260 -238h-77zM293 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 454,
    d: "M371 0l-247 228v-228h-52v456h52v-210l228 210h73l-237 -218l260 -238h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 488,
    d: "M88 0v700h52v-652h334v-48h-386zM209 932l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 238,
    d: "M116 0l2 756h50v-756h-52zM214 974l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcedilla",
    unicode: "\u013B",
    horizAdvX: 488,
    d: "M88 0v700h52v-652h334v-48h-386zM324 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcedilla",
    unicode: "\u013C",
    horizAdvX: 228,
    d: "M112 0l2 756h50v-756h-52zM156 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 488,
    d: "M88 0v700h52v-652h334v-48h-386zM259 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 294,
    d: "M210 462v238h50v-238h-50zM112 0l2 756h50v-756h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 488,
    d: "M260 360q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5zM88 0v700h52v-652h334v-48h-386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 309,
    d: "M206 360q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5zM105 0l2 756h50v-756h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 513,
    d: "M112 0v250l-77 -60l-27 36l104 81v393h52v-352l156 122l27 -36l-183 -144v-242h335v-48h-387z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 321,
    d: "M129 0v310l-90 -70l-27 36l117 91v389h56v-345l97 76l27 -36l-124 -97v-354h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 710,
    d: "M88 700h52l430 -610v610h52v-700h-52l-430 612v-612h-52v700zM474 932l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 518,
    d: "M275 468q70 0 120.5 -45t50.5 -132v-291h-52v283q0 67 -35 100.5t-94 33.5q-45 0 -80 -25.5t-48 -51.5l-13 -25v-315h-52v456h47v-83q2 4 5.5 10.5t17 22.5t30 28.5t44.5 23t59 10.5zM320 694l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncedilla",
    unicode: "\u0145",
    horizAdvX: 710,
    d: "M88 700h52l430 -610v610h52v-700h-52l-430 612v-612h-52v700zM380 -45l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncedilla",
    unicode: "\u0146",
    horizAdvX: 518,
    d: "M275 468q70 0 120.5 -45t50.5 -132v-291h-52v283q0 67 -35 100.5t-94 33.5q-45 0 -80 -25.5t-48 -51.5l-13 -25v-315h-52v456h47v-83q2 4 5.5 10.5t17 22.5t30 28.5t44.5 23t59 10.5zM298 -45l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 710,
    d: "M88 700h52l430 -610v610h52v-700h-52l-430 612v-612h-52v700zM373 758l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 518,
    d: "M275 468q70 0 120.5 -45t50.5 -132v-291h-52v283q0 67 -35 100.5t-94 33.5q-45 0 -80 -25.5t-48 -51.5l-13 -25v-315h-52v456h47v-83q2 4 5.5 10.5t17 22.5t30 28.5t44.5 23t59 10.5zM266 539l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 571,
    d: "M328 468q70 0 120.5 -45t50.5 -132v-291h-52v283q0 67 -35 100.5t-94 33.5q-45 0 -80 -25.5t-48 -51.5l-13 -25v-315h-52v456h47v-83q2 4 5.5 10.5t17 22.5t30 28.5t44.5 23t59 10.5zM24 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 710,
    d: "M440 -221l20 45q24 -15 46 -15q17 0 29 3.5t23.5 20.5t11.5 47v124l-430 601v-605h-52v700h49l433 -605v605h52v-828q0 -57 -32.5 -85.5t-75.5 -28.5q-19 0 -37.5 5t-27.5 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 518,
    d: "M275 468q71 0 121 -44t50 -132v-420q0 -57 -32.5 -85.5t-75.5 -28.5q-19 0 -37.5 5t-27.5 11l-9 5l20 45q24 -15 46 -15q17 0 29 3.5t23.5 20.5t11.5 47v394q0 143 -134 143q-25 0 -48.5 -9.5t-38.5 -22.5t-26.5 -26t-16.5 -23l-6 -9v-327h-52v456h47v-76q2 4 5.5 9.5 t17.5 21t30.5 27t44 21t58.5 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 780,
    d: "M390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5t-210.5 89.5zM239 811v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 536,
    d: "M268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54zM117 583v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 780,
    d: "M390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5t-210.5 89.5zM253 908h50v-9.5t4.5 -21 t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 536,
    d: "M268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54zM131 680h50v-9.5t4.5 -21t12.5 -27t26.5 -21 t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 774,
    d: "M390 -12q-149 0 -247.5 104.5t-98.5 257.5t99 257.5t247 104.5t247 -104.5t99 -257.5t-98.5 -257.5t-247.5 -104.5zM390 661q-129 0 -210.5 -89.5t-81.5 -221.5t81.5 -221.5t210.5 -89.5t210.5 89.5t81.5 221.5t-81.5 221.5t-210.5 89.5zM390 959l43 -28l-118 -171 l-41 25zM552 959l43 -28l-118 -171l-41 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 536,
    d: "M268 468q101 0 166.5 -69.5t65.5 -170.5t-65.5 -170.5t-166.5 -69.5t-166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54zM262 721l43 -28l-118 -171l-41 25zM424 721 l43 -28l-118 -171l-41 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 846,
    d: "M790 0h-400q-153 0 -249.5 96t-96.5 254t96.5 254t249.5 96h394v-52h-308v-262h284v-52h-284v-282h314v-52zM420 648h-30q-126 0 -207.5 -85t-81.5 -213t81.5 -213t207.5 -85h30v596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 929,
    d: "M676 468q92 0 156.5 -68t64.5 -172q0 -10 -1 -21h-393q4 -61 51.5 -114.5t130.5 -53.5q94 0 156 78l35 -36q-34 -41 -85.5 -67t-105.5 -26q-70 0 -125.5 36.5t-84.5 96.5v-4q-29 -59 -83.5 -94t-123.5 -35q-101 0 -166.5 69.5t-65.5 170.5t65.5 170.5t166.5 69.5 q68 0 122 -34t83 -91v-9q26 61 79.5 97.5t123.5 36.5zM268 39q83 0 130.5 54t47.5 135t-47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54zM505 255h338q-1 17 -6.5 37t-18.5 42.5t-31.5 40.5t-47.5 30t-63 12q-45 0 -79.5 -18t-53 -45t-28 -52.5t-10.5 -46.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 535,
    d: "M140 354h120q79 0 124.5 39.5t45.5 108.5t-46 108.5t-124 39.5h-120v-296zM88 0v700h169q106 0 166.5 -55t60.5 -143q0 -43 -14.5 -77.5t-35 -55t-47 -35t-46.5 -20t-38 -7.5l200 -307h-63l-196 304h-104v-304h-52zM337 932l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 329,
    d: "M252 468q19 0 37 -3t26 -6l8 -3l-22 -50q-19 11 -61 11q-35 0 -64 -22t-40 -44l-12 -22v-329h-52v456h47v-74q2 3 5 9t15 21t26 26t37.5 20.5t49.5 9.5zM243 712l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcedilla",
    unicode: "\u0156",
    horizAdvX: 535,
    d: "M140 354h120q79 0 124.5 39.5t45.5 108.5t-46 108.5t-124 39.5h-120v-296zM88 0v700h169q106 0 166.5 -55t60.5 -143q0 -43 -14.5 -77.5t-35 -55t-47 -35t-46.5 -20t-38 -7.5l200 -307h-63l-196 304h-104v-304h-52zM315 -45l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcedilla",
    unicode: "\u0157",
    horizAdvX: 329,
    d: "M252 468q19 0 37 -3t26 -6l8 -3l-22 -50q-19 11 -61 11q-35 0 -64 -22t-40 -44l-12 -22v-329h-52v456h47v-74q2 3 5 9t15 21t26 26t37.5 20.5t49.5 9.5zM161 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 535,
    d: "M140 354h120q79 0 124.5 39.5t45.5 108.5t-46 108.5t-124 39.5h-120v-296zM88 0v700h169q106 0 166.5 -55t60.5 -143q0 -43 -14.5 -77.5t-35 -55t-47 -35t-46.5 -20t-38 -7.5l200 -307h-63l-196 304h-104v-304h-52zM271 756l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 329,
    d: "M252 468q19 0 37 -3t26 -6l8 -3l-22 -50q-19 11 -61 11q-35 0 -64 -22t-40 -44l-12 -22v-329h-52v456h47v-74q2 3 5 9t15 21t26 26t37.5 20.5t49.5 9.5zM174 539l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 536,
    d: "M428 175q0 25 -9.5 46.5t-22 36t-36.5 29.5t-41.5 23.5t-48.5 22.5q-90 39 -139 85.5t-49 119.5q0 66 52 120t143 54q35 0 67.5 -10.5t54 -25t37.5 -29.5t24 -25l7 -11l-40 -31q-2 3 -6 8.5t-18 19.5t-30 24.5t-41.5 19.5t-53.5 9q-65 0 -104.5 -35t-39.5 -88 q0 -31 12.5 -55.5t41 -45t54 -34t71.5 -33.5q85 -37 126 -82t41 -113q0 -83 -60 -135t-149 -52q-43 0 -81.5 14.5t-62 35.5t-41 42.5t-24.5 35.5l-8 15l47 28q2 -5 6 -13t18.5 -28.5t32 -36.5t48 -29t65.5 -13q67 0 112 37t45 99zM342 932l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 447,
    d: "M37 85l41 35q2 -3 5.5 -8.5t17.5 -19.5t30 -24.5t43.5 -19.5t57.5 -9q45 0 82 19.5t37 60.5q0 35 -31 52t-96 32q-80 18 -121 50t-41 86q0 51 44.5 90t116.5 39q48 0 88.5 -16t57.5 -32l17 -16l-34 -38l-5.5 5.5t-16 12.5t-26.5 15.5t-36 12t-45 5.5q-47 0 -77.5 -21.5 t-30.5 -56.5q0 -20 9.5 -34.5t31 -25t41.5 -16t55 -13.5q73 -16 113 -45t40 -86q0 -62 -51.5 -96.5t-121.5 -34.5q-38 0 -72 10t-55.5 24.5t-37.5 28.5t-23 24zM302 712l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 536,
    d: "M428 175q0 25 -9.5 46.5t-22 36t-36.5 29.5t-41.5 23.5t-48.5 22.5q-90 39 -139 85.5t-49 119.5q0 66 52 120t143 54q35 0 67.5 -10.5t54 -25t37.5 -29.5t24 -25l7 -11l-40 -31q-2 3 -6 8.5t-18 19.5t-30 24.5t-41.5 19.5t-53.5 9q-65 0 -104.5 -35t-39.5 -88 q0 -31 12.5 -55.5t41 -45t54 -34t71.5 -33.5q85 -37 126 -82t41 -113q0 -83 -60 -135t-149 -52q-43 0 -81.5 14.5t-62 35.5t-41 42.5t-24.5 35.5l-8 15l47 28q2 -5 6 -13t18.5 -28.5t32 -36.5t48 -29t65.5 -13q67 0 112 37t45 99zM130 802l160 115l160 -115l-30 -37l-130 96 l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 447,
    d: "M37 85l41 35q2 -3 5.5 -8.5t17.5 -19.5t30 -24.5t43.5 -19.5t57.5 -9q45 0 82 19.5t37 60.5q0 35 -31 52t-96 32q-80 18 -121 50t-41 86q0 51 44.5 90t116.5 39q48 0 88.5 -16t57.5 -32l17 -16l-34 -38l-5.5 5.5t-16 12.5t-26.5 15.5t-36 12t-45 5.5q-47 0 -77.5 -21.5 t-30.5 -56.5q0 -20 9.5 -34.5t31 -25t41.5 -16t55 -13.5q73 -16 113 -45t40 -86q0 -62 -51.5 -96.5t-121.5 -34.5q-38 0 -72 10t-55.5 24.5t-37.5 28.5t-23 24zM73 567l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 536,
    d: "M428 175q0 25 -9.5 46.5t-22 36t-36.5 29.5t-41.5 23.5t-48.5 22.5q-90 39 -139 85.5t-49 119.5q0 66 52 120t143 54q35 0 67.5 -10.5t54 -25t37.5 -29.5t24 -25l7 -11l-40 -31q-2 3 -6 8.5t-18 19.5t-30 24.5t-41.5 19.5t-53.5 9q-65 0 -104.5 -35t-39.5 -88 q0 -31 12.5 -55.5t41 -45t54 -34t71.5 -33.5q85 -37 126 -82t41 -113q0 -83 -60 -135t-149 -52q-43 0 -81.5 14.5t-62 35.5t-41 42.5t-24.5 35.5l-8 15l47 28q2 -5 6 -13t18.5 -28.5t32 -36.5t48 -29t65.5 -13q67 0 112 37t45 99zM299 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 447,
    d: "M37 85l41 35q2 -3 5.5 -8.5t17.5 -19.5t30 -24.5t43.5 -19.5t57.5 -9q45 0 82 19.5t37 60.5q0 35 -31 52t-96 32q-80 18 -121 50t-41 86q0 51 44.5 90t116.5 39q48 0 88.5 -16t57.5 -32l17 -16l-34 -38l-5.5 5.5t-16 12.5t-26.5 15.5t-36 12t-45 5.5q-47 0 -77.5 -21.5 t-30.5 -56.5q0 -20 9.5 -34.5t31 -25t41.5 -16t55 -13.5q73 -16 113 -45t40 -86q0 -62 -51.5 -96.5t-121.5 -34.5q-38 0 -72 10t-55.5 24.5t-37.5 28.5t-23 24zM251 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 536,
    d: "M428 175q0 25 -9.5 46.5t-22 36t-36.5 29.5t-41.5 23.5t-48.5 22.5q-90 39 -139 85.5t-49 119.5q0 66 52 120t143 54q35 0 67.5 -10.5t54 -25t37.5 -29.5t24 -25l7 -11l-40 -31q-2 3 -6 8.5t-18 19.5t-30 24.5t-41.5 19.5t-53.5 9q-65 0 -104.5 -35t-39.5 -88 q0 -31 12.5 -55.5t41 -45t54 -34t71.5 -33.5q85 -37 126 -82t41 -113q0 -83 -60 -135t-149 -52q-43 0 -81.5 14.5t-62 35.5t-41 42.5t-24.5 35.5l-8 15l47 28q2 -5 6 -13t18.5 -28.5t32 -36.5t48 -29t65.5 -13q67 0 112 37t45 99zM278 757l-160 115l29 38l131 -97l131 97 l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 447,
    d: "M37 85l41 35q2 -3 5.5 -8.5t17.5 -19.5t30 -24.5t43.5 -19.5t57.5 -9q45 0 82 19.5t37 60.5q0 35 -31 52t-96 32q-80 18 -121 50t-41 86q0 51 44.5 90t116.5 39q48 0 88.5 -16t57.5 -32l17 -16l-34 -38l-5.5 5.5t-16 12.5t-26.5 15.5t-36 12t-45 5.5q-47 0 -77.5 -21.5 t-30.5 -56.5q0 -20 9.5 -34.5t31 -25t41.5 -16t55 -13.5q73 -16 113 -45t40 -86q0 -62 -51.5 -96.5t-121.5 -34.5q-38 0 -72 10t-55.5 24.5t-37.5 28.5t-23 24zM231 529l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcedilla",
    unicode: "\u0162",
    horizAdvX: 506,
    d: "M227 0v652h-211v48h474v-48h-211v-652h-52zM282 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcedilla",
    unicode: "\u0163",
    horizAdvX: 377,
    d: "M28 408v48h99v147h52v-147h155v-48h-155v-275q0 -94 80 -94q16 0 33 5.5t26 10.5l9 5l20 -45q-44 -27 -90 -27q-64 0 -97 37.5t-33 97.5v285h-99zM248 -55l-58 -194l-52 15l59 185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 506,
    d: "M227 0v652h-211v48h474v-48h-211v-652h-52zM253 756l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 377,
    d: "M28 408v48h99v147h52v-147h155v-48h-155v-275q0 -94 80 -94q16 0 33 5.5t26 10.5l9 5l20 -45q-44 -27 -90 -27q-64 0 -97 37.5t-33 97.5v285h-99zM284 518v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 506,
    d: "M74 408v48h153v196h-211v48h474v-48h-211v-196h153v-48h-153v-408h-52v408h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 377,
    d: "M28 408v48h99v147h52v-147h155v-48h-155v-129h155v-48h-155v-103q0 -89 80 -89q16 0 33 5.5t26 10.5l9 5l20 -45q-44 -27 -90 -27q-63 0 -96.5 37t-33.5 96v110h-99v48h99v129h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM223 803l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8 t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10zM150 565l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22 q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM186 801v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10zM108 583v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM200 908h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41 t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10zM121 700h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9 h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM238 840q0 41 29 70t70 29t70 -29t29 -70t-29 -70t-70 -29t-70 29t-29 70zM279 840q0 -25 16.5 -41.5t41.5 -16.5t42 16.5t17 41.5 t-17 42t-42 17t-41.5 -17t-16.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10zM162 641q0 41 29 70t70 29t70 -29t29 -70t-29 -70t-70 -29t-70 29t-29 70zM203 641 q0 -25 16.5 -41.5t41.5 -16.5t42 16.5t17 41.5t-17 42t-42 17t-41.5 -17t-16.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -125 -65.5 -200t-183.5 -75t-183.5 75t-65.5 200v437h52v-432q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168zM331 959l43 -28l-118 -171l-41 25zM493 959l43 -28l-118 -171l-41 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 519,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-47v81q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10zM242 721l43 -28l-118 -171l-41 25zM404 721l43 -28l-118 -171l-41 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 674,
    d: "M534 268v432h52v-437q0 -101 -43.5 -170t-123.5 -93l-5 -3q-5 -3 -10 -5.5t-12.5 -7.5t-14 -10t-13.5 -11.5t-12 -13t-8 -15t-3 -16.5q0 -21 12 -33.5t34 -12.5l34 6v-47q-17 -6 -39 -6q-37 0 -62 24t-25 61q0 49 52 78h-10q-118 0 -183.5 75t-65.5 200v437h52v-432 q0 -107 48.5 -168t148.5 -61t148.5 61t48.5 168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 518,
    d: "M243 -12q-72 0 -121.5 45t-49.5 132v291h52v-283q0 -68 34.5 -101t94.5 -33q45 0 80 25t48 50l13 25v317h52v-456h-2q-7 -2 -16 -6t-25 -13t-26.5 -25.5t-10.5 -36.5q0 -21 12 -34t34 -13l34 6v-47q-17 -6 -39 -6q-37 0 -62 24.5t-25 61.5q0 33 20 58t40 34l19 9v69 q-2 -4 -5.5 -10t-17 -22t-30 -28.5t-44.5 -22.5t-59 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 939,
    d: "M935 700l-258 -720l-207 634l-208 -634l-258 720h56l204 -572l179 572h53l182 -572l202 572h55zM310 792l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 744,
    d: "M10 456h56l148 -357l145 357h30l144 -357l147 357h54l-204 -476l-158 381l-159 -381zM212 557l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 568,
    d: "M258 0v275l-242 425h60l209 -372l209 372h58l-242 -425v-275h-52zM124 802l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 489,
    d: "M31 -202l31 42q27 -31 62 -31q25 0 40.5 14.5t29.5 49.5l47 119l-227 464h56l198 -409l159 409h54q-230 -578 -241 -605q-20 -50 -48.5 -71.5t-71.5 -21.5q-21 0 -43.5 10t-34.5 20zM92 567l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 568,
    d: "M258 0v275l-242 425h60l209 -372l209 372h58l-242 -425v-275h-52zM155 842q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28zM336 842q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 564,
    d: "M47 700h493l-426 -652h411v-48h-501l426 652h-403v48zM370 938l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 465,
    d: "M321 712l35 -35l-150 -147l-34 33zM59 456h372l-301 -408h290v-48h-382l301 408h-280v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 564,
    d: "M47 700h493l-426 -652h411v-48h-501l426 652h-403v48zM252 828q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 465,
    d: "M199 603q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5zM59 456h372l-301 -408h290v-48h-382l301 408h-280v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 564,
    d: "M47 700h493l-426 -652h411v-48h-501l426 652h-403v48zM299 756l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 474,
    d: "M245 529l-160 115l29 38l131 -97l131 97l29 -38zM59 456h372l-301 -408h290v-48h-382l301 408h-280v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "longs",
    unicode: "\u017F",
    horizAdvX: 313,
    d: "M173 623v-623h-52v408h-98v48h98v179q0 63 38.5 98t88.5 35q23 0 44 -5t30 -11l10 -5l-22 -46q-27 16 -57 16q-39 0 -59.5 -25.5t-20.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    d: "M328 408l-65 -372q-16 -94 -61 -138.5t-126 -44.5h-36v48h34q31 0 55 9.5t38 22.5t23.5 34t13.5 36.5t8 37.5l64 367h-96l8 48h96l30 165q26 147 151 147q19 0 40 -5.5t33 -10.5l11 -6l-20 -45q-27 16 -62 16q-84 0 -102 -101l-29 -160h130l-8 -48h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophemod",
    unicode: "\u02BC",
    horizAdvX: 150,
    d: "M50 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 418,
    d: "M49 554l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 418,
    d: "M209 533l-160 115l29 38l131 -97l131 97l29 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 410,
    d: "M68 700h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 239,
    d: "M79 600q0 17 11.5 29t28.5 12t29 -12t12 -29t-12 -28.5t-29 -11.5t-28.5 11.5t-11.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 242,
    d: "M22 633q0 41 29 70t70 29t70 -29t29 -70t-29 -70t-70 -29t-70 29t-29 70zM63 633q0 -25 16.5 -41.5t41.5 -16.5t42 16.5t17 41.5t-17 42t-42 17t-41.5 -17t-16.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 219,
    d: "M110 0h47q-9 -4 -22.5 -11t-35.5 -28.5t-22 -42.5t12 -33.5t34 -12.5l34 6v-47q-17 -6 -39 -6q-37 0 -62 24t-25 61q0 19 8 35t19.5 25.5t23.5 16.5t20 10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 390,
    d: "M83 565l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 382,
    d: "M143 721l43 -28l-118 -171l-41 25zM305 721l43 -28l-118 -171l-41 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u0394",
    horizAdvX: 836,
    d: "M4 0l414 756l414 -756h-828zM86 48h664l-332 605z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 836,
    d: "M4 0l414 756l414 -756h-828zM86 48h664l-332 605z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 788,
    d: "M195 48l23 -2q-77 45 -123.5 125t-46.5 179q0 153 98 257.5t248 104.5t248 -104.5t98 -257.5q0 -99 -46.5 -179t-123.5 -125l22 2h119v-48h-240v41q98 30 156.5 114.5t58.5 194.5q0 131 -82 221t-210 90t-210 -90t-82 -221q0 -110 58.5 -194.5t156.5 -114.5v-41h-240v48 h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 788,
    d: "M195 48l23 -2q-77 45 -123.5 125t-46.5 179q0 153 98 257.5t248 104.5t248 -104.5t98 -257.5q0 -99 -46.5 -179t-123.5 -125l22 2h119v-48h-240v41q98 30 156.5 114.5t58.5 194.5q0 131 -82 221t-210 90t-210 -90t-82 -221q0 -110 58.5 -194.5t156.5 -114.5v-41h-240v48 h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 579,
    d: "M519 54l20 -45q-31 -21 -74 -21t-75.5 28t-32.5 85v307h-155v-408h-52v408h-108v48h485v-48h-118v-298q0 -43 18.5 -57t45.5 -14q10 0 21.5 3.5t17.5 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 939,
    d: "M935 700l-258 -720l-207 634l-208 -634l-258 720h56l204 -572l179 572h53l182 -572l202 572h55zM339 902l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 744,
    d: "M248 675l39 37l149 -149l-35 -33zM10 456h56l148 -357l145 357h30l144 -357l147 357h54l-204 -476l-158 381l-159 -381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 939,
    d: "M935 700l-258 -720l-207 634l-208 -634l-258 720h56l204 -572l179 572h53l182 -572l202 572h55zM559 938l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 744,
    d: "M10 456h56l148 -357l145 357h30l144 -357l147 357h54l-204 -476l-158 381l-159 -381zM473 712l35 -35l-150 -147l-34 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 568,
    d: "M258 0v275l-242 425h60l209 -372l209 372h58l-242 -425v-275h-52zM148 901l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 489,
    d: "M31 -202l31 42q27 -31 62 -31q25 0 40.5 14.5t29.5 49.5l47 119l-227 464h56l198 -409l159 409h54q-230 -578 -241 -605q-20 -50 -48.5 -71.5t-71.5 -21.5q-21 0 -43.5 10t-34.5 20zM121 675l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0 220v48h500v-48h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0 220v48h1000v-48h-1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 150,
    d: "M50 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 150,
    d: "M50 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 150,
    d: "M50 -140v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 334,
    d: "M80 462v238h50v-238h-50zM204 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 334,
    d: "M80 462v238h50v-238h-50zM204 462v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 334,
    d: "M80 -140v238h50v-238h-50zM204 -140v238h50v-238h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 520,
    d: "M80 456v48h153v196h52v-196h155v-48h-155v-536h-52v536h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 520,
    d: "M80 116v48h153v292h-153v48h153v196h52v-196h155v-48h-155v-292h155v-48h-155v-196h-52v196h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 500,
    d: "M162 350q0 37 25.5 62.5t62.5 25.5t62.5 -25.5t25.5 -62.5t-25.5 -62.5t-62.5 -25.5t-62.5 25.5t-25.5 62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1000,
    d: "M130 28q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM460 28q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM790 28q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1072,
    d: "M189 712q65 0 111 -45t46 -110t-46 -110t-111 -45t-111 45t-46 110t46 110t111 45zM523 298q65 0 111 -45t46 -110t-46 -110t-111 -45t-111 45t-46 110t46 110t111 45zM80 557q0 -45 31.5 -77t77.5 -32t77.5 32t31.5 77t-31.5 77t-77.5 32t-77.5 -32t-31.5 -77zM414 143 q0 -45 31.5 -77t77.5 -32t77.5 32t31.5 77t-31.5 77t-77.5 32t-77.5 -32t-31.5 -77zM883 298q65 0 111 -45t46 -110t-46 -110t-111 -45t-111 45t-46 110t46 110t111 45zM774 143q0 -45 31.5 -77t77.5 -32t77.5 32t31.5 77t-31.5 77t-77.5 32t-77.5 -32t-31.5 -77zM92 -3 l475 730l35 -24l-475 -730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 298,
    d: "M22 245l172 224l40 -31l-149 -193l149 -193l-40 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 298,
    d: "M104 469l172 -224l-172 -224l-40 31l149 193l-149 193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 120,
    d: "M-195 -3l475 730l35 -24l-475 -730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 380,
    d: "M190 806q72 0 111 -61t39 -148t-39 -148t-111 -61q-73 0 -111.5 60.5t-38.5 148.5t38.5 148.5t111.5 60.5zM190 430q39 0 64.5 26t35 62t9.5 79t-9.5 79t-35 62t-64.5 26t-64.5 -26t-35 -62t-9.5 -79t9.5 -79t35 -62t64.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 341,
    d: "M8 487l217 313h36v-273h54v-40h-54v-93h-42v93h-211zM82 527h137v200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 378,
    d: "M330 526q0 -65 -43.5 -101.5t-101.5 -36.5q-46 0 -79 23t-44 45l-10 23l39 19l2.5 -7.5t9 -16t17 -20.5t27 -16.5t38.5 -7.5q40 0 70.5 25.5t30.5 70.5t-29.5 71.5t-69.5 26.5q-28 0 -56 -10.5t-43 -21.5l-14 -10v218h249v-40h-207v-111q34 17 76 17q55 0 96.5 -36 t41.5 -104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 354,
    d: "M226 801l-88 -144q19 8 40 8q65 0 103.5 -40.5t38.5 -96.5q0 -57 -38.5 -98.5t-102.5 -41.5t-102.5 42t-38.5 98q0 38 28 87l127 208zM179 623q-44 0 -70.5 -28t-26.5 -67q0 -40 26.5 -69t70.5 -29t70.5 29t26.5 69q0 39 -26.5 67t-70.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 319,
    d: "M28 760v40h287l-216 -416l-37 20l185 356h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 350,
    d: "M175 806q55 0 87 -33t32 -77q0 -28 -12.5 -51.5t-31.5 -34.5q27 -13 42.5 -40t15.5 -60q0 -52 -37 -87t-96 -35t-96 35t-37 87q0 33 15.5 60t42.5 40q-19 11 -31.5 34.5t-12.5 51.5q0 44 32 77t87 33zM175 430q43 0 66 23.5t23 56.5t-23 56.5t-66 23.5t-66 -23.5 t-23 -56.5t23 -56.5t66 -23.5zM175 624q37 0 56 21t19 49t-19 49t-56 21t-56 -21t-19 -49t19 -49t56 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 354,
    d: "M134 403l83 134q-20 -8 -41 -8q-65 0 -103.5 40.5t-38.5 96.5q0 57 38.5 98.5t102.5 41.5t102.5 -42t38.5 -98q0 -38 -28 -87l-121 -198zM175 571q44 0 70.5 28t26.5 67q0 40 -26.5 69t-70.5 29t-70.5 -29t-26.5 -69q0 -39 26.5 -67t70.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 380,
    d: "M190 319q72 0 111 -61t39 -148t-39 -148t-111 -61q-73 0 -111.5 60.5t-38.5 148.5t38.5 148.5t111.5 60.5zM190 -57q39 0 64.5 26t35 62t9.5 79t-9.5 79t-35 62t-64.5 26t-64.5 -26t-35 -62t-9.5 -79t9.5 -79t35 -62t64.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 276,
    d: "M16 195l142 118h34v-406h-42v345l-108 -89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 351,
    d: "M240 72l-111 -125h176v-40h-272l165 181q1 2 7.5 9t8.5 9t8 9t8 10t6.5 9.5t6.5 10.5t5 10.5t4.5 11.5t2.5 11t1 12q0 35 -23 61t-68 26q-66 0 -93 -72l-39 16q14 43 48 70.5t84 27.5q60 0 97.5 -35.5t37.5 -93.5q0 -30 -14.5 -56t-45.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 358,
    d: "M261 204q0 30 -20 51.5t-62 21.5q-29 0 -50.5 -14.5t-28.5 -28.5l-7 -15l-36 18q1 3 4 8.5t13 20t22.5 25t35 19.5t47.5 9q57 0 91.5 -32.5t34.5 -82.5q0 -28 -14.5 -50t-28.5 -30l-15 -8q3 -1 7 -2.5t15 -8.5t19 -17t15 -28.5t7 -42.5q0 -52 -40.5 -84t-93.5 -32 q-48 0 -81 24t-43 48l-9 24l38 17l2.5 -7.5t8.5 -17t16.5 -22t27.5 -17t40 -7.5q41 0 65.5 21.5t24.5 52.5q0 35 -24 56.5t-63 21.5h-23v39h23q35 0 58.5 18.5t23.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 341,
    d: "M8 0l217 313h36v-273h54v-40h-54v-93h-42v93h-211zM82 40h137v200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 378,
    d: "M330 39q0 -65 -43.5 -101.5t-101.5 -36.5q-29 0 -53 9.5t-38.5 22.5t-24.5 26.5t-13 22.5l-4 10l39 19l2.5 -7.5t9 -16t17 -20.5t27 -16.5t38.5 -7.5q40 0 70.5 25.5t30.5 70.5t-29.5 71.5t-69.5 26.5q-28 0 -56 -10.5t-43 -20.5l-14 -11v218h249v-40h-207v-111 q34 17 76 17q55 0 96.5 -36t41.5 -104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 354,
    d: "M226 314l-88 -144q19 8 40 8q65 0 103.5 -40.5t38.5 -96.5q0 -57 -38.5 -98.5t-102.5 -41.5t-102.5 42t-38.5 98q0 38 28 87l127 208zM179 136q-44 0 -70.5 -28t-26.5 -67q0 -40 26.5 -69t70.5 -29t70.5 29t26.5 69q0 39 -26.5 67t-70.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 319,
    d: "M28 273v40h287l-216 -416l-37 20l185 356h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 350,
    d: "M175 319q55 0 87 -33t32 -77q0 -28 -12.5 -51.5t-31.5 -34.5q27 -13 42.5 -40t15.5 -60q0 -52 -37 -87t-96 -35t-96 35t-37 87q0 33 15.5 60t42.5 40q-19 11 -31.5 34.5t-12.5 51.5q0 44 32 77t87 33zM175 -57q43 0 66 23.5t23 56.5t-23 56.5t-66 23.5t-66 -23.5 t-23 -56.5t23 -56.5t66 -23.5zM175 137q37 0 56 21t19 49t-19 49t-56 21t-56 -21t-19 -49t19 -49t56 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 354,
    d: "M134 -84l83 134q-20 -8 -41 -8q-65 0 -103.5 40.5t-38.5 96.5q0 57 38.5 98.5t102.5 41.5t102.5 -42t38.5 -98q0 -38 -28 -87l-121 -198zM175 84q44 0 70.5 28t26.5 67q0 40 -26.5 69t-70.5 29t-70.5 -29t-26.5 -69q0 -39 26.5 -67t70.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    d: "M33 383v47h81q22 125 107 203.5t213 78.5q32 0 62 -5t44 -10l14 -5l-17 -47q-38 16 -103 16q-97 0 -169.5 -63t-94.5 -168h267v-47h-274q-1 -11 -1 -33q0 -23 1 -33h274v-47h-267q22 -105 94.5 -168t169.5 -63q29 0 55 4.5t38 8.5l12 5l16 -47q-50 -22 -121 -22 q-130 0 -213.5 77.5t-106.5 204.5h-81v47h76q-1 10 -1 33q0 22 1 33h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numero",
    unicode: "\u2116",
    horizAdvX: 1104,
    d: "M719 255v48h314v-48h-314zM876 712q80 0 126 -53.5t46 -117.5t-46 -117.5t-126 -53.5t-126 53.5t-46 117.5t46 117.5t126 53.5zM756 541q0 -49 35 -84.5t85 -35.5t85 35.5t35 84.5t-35 84.5t-85 35.5t-85 -35.5t-35 -84.5zM88 700h52l430 -610v610h52v-700h-52l-430 612 v-612h-52v700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 755,
    d: "M123 330v332h-107v38h257v-38h-109v-332h-41zM348 700h43l131 -207l131 207h43v-370h-41v300l-133 -209l-133 209v-300h-41v370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 830,
    d: "M155 -3l475 730l35 -24l-475 -730zM51 582l142 118h34v-406h-42v345l-108 -89zM731 297q0 30 -20 51.5t-62 21.5q-29 0 -50.5 -14.5t-28.5 -29.5l-7 -14l-36 18q1 3 4 8.5t13 20t22.5 25t35 19.5t47.5 9q57 0 91.5 -32.5t34.5 -82.5q0 -28 -14.5 -50t-28.5 -30l-15 -8 q3 -1 7 -2.5t15 -8.5t19 -17t15 -28.5t7 -42.5q0 -52 -40.5 -84t-93.5 -32q-48 0 -81 24t-43 48l-9 24l38 17l2.5 -7.5t8.5 -17t16.5 -22t27.5 -17t40 -7.5q41 0 65.5 21.5t24.5 52.5q0 35 -24 56.5t-63 21.5h-23v39h23q35 0 58.5 18.5t23.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 830,
    d: "M230 459l-111 -125h176v-40h-272l165 181q1 2 7.5 9t8.5 9t8 9t8 10t6.5 9.5t6.5 10.5t5 10.5t4.5 11.5t2.5 11t1 12q0 35 -23 61t-68 26q-66 0 -93 -72l-39 16q14 43 48 70.5t84 27.5q60 0 97.5 -35.5t37.5 -93.5q0 -30 -14.5 -56t-45.5 -62zM733 297q0 30 -20 51.5 t-62 21.5q-29 0 -50.5 -14.5t-28.5 -29.5l-7 -14l-36 18q1 3 4 8.5t13 20t22.5 25t35 19.5t47.5 9q57 0 91.5 -32.5t34.5 -82.5q0 -28 -14.5 -50t-28.5 -30l-15 -8q3 -1 7 -2.5t15 -8.5t19 -17t15 -28.5t7 -42.5q0 -52 -40.5 -84t-93.5 -32q-48 0 -81 24t-43 48l-9 24l38 17 l2.5 -7.5t8.5 -17t16.5 -22t27.5 -17t40 -7.5q41 0 65.5 21.5t24.5 52.5q0 35 -24 56.5t-63 21.5h-23v39h23q35 0 58.5 18.5t23.5 51.5zM172 -3l475 730l35 -24l-475 -730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 830,
    d: "M160 -3l475 730l35 -24l-475 -730zM653 412q55 0 87 -33t32 -77q0 -28 -12.5 -51.5t-31.5 -34.5q27 -13 42.5 -40t15.5 -60q0 -52 -37 -87t-96 -35t-96 35t-37 87q0 33 15.5 60t42.5 40q-19 11 -31.5 34.5t-12.5 51.5q0 44 32 77t87 33zM653 36q43 0 66 23.5t23 56.5 t-23 56.5t-66 23.5t-66 -23.5t-23 -56.5t23 -56.5t66 -23.5zM653 230q37 0 56 21t19 49t-19 49t-56 21t-56 -21t-19 -49t19 -49t56 -21zM51 582l142 118h34v-406h-42v345l-108 -89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 830,
    d: "M165 -3l475 730l35 -24l-475 -730zM262 591q0 30 -20 51.5t-62 21.5q-29 0 -50.5 -14.5t-28.5 -29.5l-7 -14l-36 18q1 3 4 8.5t13 20t22.5 25t35 19.5t47.5 9q57 0 91.5 -32.5t34.5 -82.5q0 -28 -14.5 -50t-29.5 -30l-14 -8q3 -1 7 -2.5t15 -8.5t19 -17t15 -28.5t7 -42.5 q0 -52 -40.5 -84t-93.5 -32q-30 0 -55 10t-39 24t-23.5 28t-12.5 24l-3 10l38 17l2.5 -7.5t8.5 -17t16.5 -22t27.5 -17t40 -7.5q41 0 65.5 21.5t24.5 52.5q0 35 -24 56.5t-63 21.5h-23v39h23q35 0 58.5 18.5t23.5 51.5zM653 412q55 0 87 -33t32 -77q0 -28 -12.5 -51.5 t-31.5 -34.5q27 -13 42.5 -40t15.5 -60q0 -52 -37 -87t-96 -35t-96 35t-37 87q0 33 15.5 60t42.5 40q-19 11 -31.5 34.5t-12.5 51.5q0 44 32 77t87 33zM653 36q43 0 66 23.5t23 56.5t-23 56.5t-66 23.5t-66 -23.5t-23 -56.5t23 -56.5t66 -23.5zM653 230q37 0 56 21t19 49 t-19 49t-56 21t-56 -21t-19 -49t19 -49t56 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 830,
    d: "M325 426q0 -65 -43.5 -101.5t-101.5 -36.5q-46 0 -79 23t-43 45l-11 23l39 19l2.5 -7.5t9 -16t17 -20.5t27 -16.5t38.5 -7.5q40 0 70.5 25.5t30.5 70.5t-29.5 71.5t-69.5 26.5q-28 0 -56 -10.5t-42 -21.5l-15 -10v218h249v-40h-207v-111q34 17 76 17q55 0 96.5 -36 t41.5 -104zM166 -3l475 730l35 -24l-475 -730zM653 412q55 0 87 -33t32 -77q0 -28 -12.5 -51.5t-31.5 -34.5q27 -13 42.5 -40t15.5 -60q0 -52 -37 -87t-96 -35t-96 35t-37 87q0 33 15.5 60t42.5 40q-19 11 -31.5 34.5t-12.5 51.5q0 44 32 77t87 33zM653 36q43 0 66 23.5 t23 56.5t-23 56.5t-66 23.5t-66 -23.5t-23 -56.5t23 -56.5t66 -23.5zM653 230q37 0 56 21t19 49t-19 49t-56 21t-56 -21t-19 -49t19 -49t56 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 830,
    d: "M79 660v40h287l-216 -416l-37 20l185 356h-219zM155 -3l475 730l35 -24l-475 -730zM663 412q55 0 87 -33t32 -77q0 -28 -12.5 -51.5t-31.5 -34.5q27 -13 42.5 -40t15.5 -60q0 -52 -37 -87t-96 -35t-96 35t-37 87q0 33 15.5 60t42.5 40q-19 11 -31.5 34.5t-12.5 51.5 q0 44 32 77t87 33zM663 36q43 0 66 23.5t23 56.5t-23 56.5t-66 23.5t-66 -23.5t-23 -56.5t23 -56.5t66 -23.5zM663 230q37 0 56 21t19 49t-19 49t-56 21t-56 -21t-19 -49t19 -49t56 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowleft",
    unicode: "\u2190",
    horizAdvX: 760,
    d: "M732 273v-52h-629l181 -202l-37 -35l-229 263l229 263l37 -35l-181 -202h629z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowup",
    unicode: "\u2191",
    horizAdvX: 598,
    d: "M325 0h-52v629l-202 -181l-35 37l263 229l263 -229l-35 -37l-202 181v-629z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowright",
    unicode: "\u2192",
    horizAdvX: 760,
    d: "M28 221v52h629l-181 202l37 35l229 -263l-229 -263l-37 35l181 202h-629z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowdown",
    unicode: "\u2193",
    horizAdvX: 598,
    d: "M273 700h52v-629l202 181l35 -37l-263 -229l-263 229l35 37l202 -181v629z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni21B3",
    unicode: "\u21B3",
    horizAdvX: 796,
    d: "M60 221v479h52v-427h576l-181 202l38 35l229 -263l-229 -263l-38 35l181 202h-628z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "carriagereturn",
    unicode: "\u21B5",
    horizAdvX: 796,
    d: "M736 700v-479h-628l181 -202l-38 -35l-229 263l229 263l38 -35l-181 -202h576v427h52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 548,
    d: "M266 468q32 0 60 -7.5t46 -18t31.5 -21t19.5 -17.5l6 -8q-16 64 -54 115.5t-80.5 79t-82.5 45.5t-66 24l-27 5l12 47q8 -1 21 -3.5t51 -15.5t73 -31t77 -54t72.5 -81t51.5 -114.5t21 -152.5v-12q0 -118 -64.5 -189t-167.5 -71q-101 0 -166.5 69.5t-65.5 170.5t65.5 170.5 t166.5 69.5zM266 39q81 0 129.5 57t48.5 132q0 81 -47.5 135t-130.5 54t-130.5 -54t-47.5 -135t47.5 -135t130.5 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 707,
    d: "M607 700v-930h-54v878h-399v-878h-54v930h507z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 738,
    d: "M34 -230l345 466l-343 464h644v-54h-538l306 -410l-308 -412h540v-54h-646z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 520,
    d: "M45 213v50h430v-50h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 625,
    d: "M323 121l268 839h52l-310 -972l-202 420h-91v48h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 838,
    d: "M42 247q0 72 48 120q51 51 124 51q69 0 128 -59l77 -81l77 81q59 59 128 59q73 0 124 -51q48 -48 48 -120t-48 -120q-51 -51 -124 -51q-69 0 -128 59l-77 81l-77 -81q-59 -59 -128 -59q-73 0 -124 51q-48 48 -48 120zM122 158q38 -38 90 -38q51 0 98 42l83 85 q-61 65 -83 85q-47 42 -98 42q-52 0 -90 -38q-37 -37 -37 -89t37 -89zM716 158q37 37 37 89t-37 89q-38 38 -90 38q-51 0 -98 -42l-83 -85q61 -65 83 -85q47 -42 98 -42q52 0 90 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 418,
    d: "M365 747l-20 -45q-24 15 -46 15q-17 0 -29 -3.5t-23.5 -20.5t-11.5 -47v-774q0 -57 -32.5 -85.5t-75.5 -28.5q-19 0 -37.5 5t-27.5 11l-9 5l20 45q24 -15 46 -15q17 0 29 3.5t23.5 20.5t11.5 47v774q0 57 32.5 85.5t75.5 28.5q19 0 37.5 -5t27.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 520,
    d: "M100 276l-39 24q1 3 3.5 8.5t11.5 18.5t21 23t33 18.5t46 8.5q30 0 86.5 -28t75.5 -28q28 0 43.5 14t16.5 28l1 14l39 -24q0 -3 -1.5 -8.5t-8.5 -19t-16.5 -24t-29.5 -19t-45 -8.5q-26 0 -80.5 27.5t-76.5 27.5q-28 0 -48 -13.5t-26 -26.5zM121 139l-41 26q1 3 3 8.5 t10.5 18.5t20 23t32 18.5t45.5 8.5q30 0 84.5 -28t76.5 -28q28 0 45 14t20 28l3 14l39 -24q-1 -3 -2.5 -8.5t-8.5 -19t-17.5 -24t-30.5 -19t-45 -8.5q-29 0 -84 27.5t-76 27.5q-28 0 -46.5 -14t-22.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 520,
    d: "M58 308v48h228l156 294l37 -20l-145 -274h128v-48h-154l-46 -88h200v-48h-226l-148 -281l-37 20l138 261h-131v48h156l47 88h-203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 520,
    d: "M12 0v48h462v-48h-462zM12 349v54l462 197v-52l-407 -172l407 -173v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 520,
    d: "M508 48v-48h-462v48h462zM508 403v-54l-462 -198v52l407 173l-407 172v52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 460,
    d: "M230 73l169 283l-169 273l-168 -273zM8 356l222 356l223 -356l-223 -370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOX",
    unicode: "\u2610",
    horizAdvX: 844,
    d: "M82 0v700h680v-700h-680zM134 649v-598h576v598h-576z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOXWITHCHECK",
    unicode: "\u2611",
    horizAdvX: 844,
    d: "M619 574l-199 -452h-43l-136 228h62l92 -158l164 382h60zM82 0v700h680v-700h-680zM134 649v-598h576v598h-576z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "BALLOTBOXWITHX",
    unicode: "\u2612",
    horizAdvX: 844,
    d: "M634 541l-174 -191l174 -191l-40 -40l-172 189l-171 -189l-40 40l173 191l-173 191l40 40l171 -189l172 189zM82 0v700h680v-700h-680zM134 649v-598h576v598h-576z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "heart",
    unicode: "\u2665",
    horizAdvX: 654,
    d: "M327 127l-240 239q-42 42 -42 101t42 100q41 41 100 41q58 0 99 -41q36 -36 41 -86q5 51 40 86q41 41 100 41q57 0 100 -41q42 -41 42 -100q0 -61 -42 -101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2709",
    unicode: "\u2709",
    horizAdvX: 844,
    d: "M20 0v700h804v-700h-804zM422 224l-350 378v-551h700v551zM97 649l325 -351l326 351h-651z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni270E",
    unicode: "\u270E",
    horizAdvX: 844,
    d: "M819 434l-383 -382l-371 -52l52 371l382 383zM439 128l307 307l-246 246l-307 -307zM262 81l135 17l-234 234l-17 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2717",
    unicode: "\u2717",
    horizAdvX: 844,
    d: "M761 675l-303 -325l303 -325l-38 -36l-301 322l-301 -322l-38 36l303 325l-303 325l38 36l301 -323l301 323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni27F5",
    unicode: "\u27F5",
    horizAdvX: 1000,
    d: "M968 273v-52h-865l181 -202l-37 -35l-229 263l229 263l37 -35l-181 -202h865z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni27F6",
    unicode: "\u27F6",
    horizAdvX: 1000,
    d: "M32 221v52h865l-181 202l37 35l229 -263l-229 -263l-37 35l181 202h-865z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    unicode: "\uF655",
    horizAdvX: 380,
    d: "M190 412q72 0 111 -61t39 -148t-39 -148t-111 -61q-73 0 -111.5 60.5t-38.5 148.5t38.5 148.5t111.5 60.5zM190 36q39 0 64.5 26t35 62t9.5 79t-9.5 79t-35 62t-64.5 26t-64.5 -26t-35 -62t-9.5 -79t9.5 -79t35 -62t64.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    unicode: "\uF656",
    horizAdvX: 276,
    d: "M14 288l142 118h34v-406h-42v345l-108 -89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    unicode: "\uF657",
    horizAdvX: 351,
    d: "M240 165l-111 -125h176v-40h-272l165 181q1 2 7.5 9t8.5 9t8 9t8 10t6.5 9.5t6.5 10.5t5 10.5t4.5 11.5t2.5 11t1 12q0 35 -23 61t-68 26q-66 0 -93 -72l-39 16q14 43 48 70.5t84 27.5q60 0 97.5 -35.5t37.5 -93.5q0 -30 -14.5 -56t-45.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    unicode: "\uF658",
    horizAdvX: 358,
    d: "M261 297q0 30 -20 51.5t-62 21.5q-29 0 -50.5 -14.5t-28.5 -29.5l-7 -14l-36 18q1 3 4 8.5t13 20t22.5 25t35 19.5t47.5 9q57 0 91.5 -32.5t34.5 -82.5q0 -28 -14.5 -50t-28.5 -30l-15 -8q3 -1 7 -2.5t15 -8.5t19 -17t15 -28.5t7 -42.5q0 -52 -40.5 -84t-93.5 -32 q-48 0 -81 24t-43 48l-9 24l38 17l2.5 -7.5t8.5 -17t16.5 -22t27.5 -17t40 -7.5q41 0 65.5 21.5t24.5 52.5q0 35 -24 56.5t-63 21.5h-23v39h23q35 0 58.5 18.5t23.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    unicode: "\uF659",
    horizAdvX: 341,
    d: "M8 93l217 313h36v-273h54v-40h-54v-93h-42v93h-211zM82 133h137v200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    unicode: "\uF65A",
    horizAdvX: 378,
    d: "M330 132q0 -65 -43.5 -101.5t-101.5 -36.5q-29 0 -53 9.5t-38.5 22.5t-24.5 26.5t-13 23.5l-4 9l39 19l2.5 -7.5t9 -16t17 -20.5t27 -16.5t38.5 -7.5q40 0 70.5 25.5t30.5 70.5t-29.5 71.5t-69.5 26.5q-28 0 -56 -10.5t-43 -21.5l-14 -10v218h249v-40h-207v-111 q34 17 76 17q55 0 96.5 -36t41.5 -104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    unicode: "\uF65B",
    horizAdvX: 354,
    d: "M226 407l-88 -144q19 8 40 8q65 0 103.5 -40.5t38.5 -96.5q0 -57 -38.5 -98.5t-102.5 -41.5t-102.5 42t-38.5 98q0 38 28 87l127 208zM179 229q-44 0 -70.5 -28t-26.5 -67q0 -40 26.5 -69t70.5 -29t70.5 29t26.5 69q0 39 -26.5 67t-70.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    unicode: "\uF65C",
    horizAdvX: 319,
    d: "M28 366v40h287l-216 -416l-37 20l185 356h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    unicode: "\uF65D",
    horizAdvX: 350,
    d: "M175 412q55 0 87 -33t32 -77q0 -28 -12.5 -51.5t-31.5 -34.5q27 -13 42.5 -40t15.5 -60q0 -52 -37 -87t-96 -35t-96 35t-37 87q0 33 15.5 60t42.5 40q-19 11 -31.5 34.5t-12.5 51.5q0 44 32 77t87 33zM175 36q43 0 66 23.5t23 56.5t-23 56.5t-66 23.5t-66 -23.5 t-23 -56.5t23 -56.5t66 -23.5zM175 230q37 0 56 21t19 49t-19 49t-56 21t-56 -21t-19 -49t19 -49t56 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    unicode: "\uF65E",
    horizAdvX: 354,
    d: "M134 9l83 134q-20 -8 -41 -8q-65 0 -103.5 40.5t-38.5 96.5q0 57 38.5 98.5t102.5 41.5t102.5 -42t38.5 -98q0 -38 -28 -87l-121 -198zM175 177q44 0 70.5 28t26.5 67q0 40 -26.5 69t-70.5 29t-70.5 -29t-26.5 -69q0 -39 26.5 -67t70.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    unicode: "\uF661",
    horizAdvX: 380,
    d: "M190 706q72 0 111 -61t39 -148t-39 -148t-111 -61q-73 0 -111.5 60.5t-38.5 148.5t38.5 148.5t111.5 60.5zM190 330q39 0 64.5 26t35 62t9.5 79t-9.5 79t-35 62t-64.5 26t-64.5 -26t-35 -62t-9.5 -79t9.5 -79t35 -62t64.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    unicode: "\uF662",
    horizAdvX: 276,
    d: "M14 582l142 118h34v-406h-42v345l-108 -89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    unicode: "\uF663",
    horizAdvX: 351,
    d: "M240 459l-111 -125h176v-40h-272l165 181q1 2 7.5 9t8.5 9t8 9t8 10t6.5 9.5t6.5 10.5t5 10.5t4.5 11.5t2.5 11t1 12q0 35 -23 61t-68 26q-66 0 -93 -72l-39 16q14 43 48 70.5t84 27.5q60 0 97.5 -35.5t37.5 -93.5q0 -30 -14.5 -56t-45.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    unicode: "\uF664",
    horizAdvX: 358,
    d: "M261 591q0 30 -20 51.5t-62 21.5q-29 0 -50.5 -14.5t-28.5 -29.5l-7 -14l-36 18q1 3 4 8.5t13 20t22.5 25t35 19.5t47.5 9q57 0 91.5 -32.5t34.5 -82.5q0 -28 -14.5 -50t-28.5 -30l-15 -8q3 -1 7 -2.5t15 -8.5t19 -17t15 -28.5t7 -42.5q0 -52 -40.5 -84t-93.5 -32 q-48 0 -81 24t-43 48l-9 24l38 17l2.5 -7.5t8.5 -17t16.5 -22t27.5 -17t40 -7.5q41 0 65.5 21.5t24.5 52.5q0 35 -24 56.5t-63 21.5h-23v39h23q35 0 58.5 18.5t23.5 51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    unicode: "\uF665",
    horizAdvX: 341,
    d: "M8 387l217 313h36v-273h54v-40h-54v-93h-42v93h-211zM82 427h137v200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    unicode: "\uF666",
    horizAdvX: 378,
    d: "M330 426q0 -65 -43.5 -101.5t-101.5 -36.5q-46 0 -79 23t-44 45l-10 23l39 19l2.5 -7.5t9 -16t17 -20.5t27 -16.5t38.5 -7.5q40 0 70.5 25.5t30.5 70.5t-29.5 71.5t-69.5 26.5q-28 0 -56 -10.5t-43 -21.5l-14 -10v218h249v-40h-207v-111q34 17 76 17q55 0 96.5 -36 t41.5 -104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    unicode: "\uF667",
    horizAdvX: 354,
    d: "M226 701l-88 -144q19 8 40 8q65 0 103.5 -40.5t38.5 -96.5q0 -57 -38.5 -98.5t-102.5 -41.5t-102.5 42t-38.5 98q0 38 28 87l127 208zM179 523q-44 0 -70.5 -28t-26.5 -67q0 -40 26.5 -69t70.5 -29t70.5 29t26.5 69q0 39 -26.5 67t-70.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    unicode: "\uF668",
    horizAdvX: 319,
    d: "M28 660v40h287l-216 -416l-37 20l185 356h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    unicode: "\uF669",
    horizAdvX: 350,
    d: "M175 706q55 0 87 -33t32 -77q0 -28 -12.5 -51.5t-31.5 -34.5q27 -13 42.5 -40t15.5 -60q0 -52 -37 -87t-96 -35t-96 35t-37 87q0 33 15.5 60t42.5 40q-19 11 -31.5 34.5t-12.5 51.5q0 44 32 77t87 33zM175 330q43 0 66 23.5t23 56.5t-23 56.5t-66 23.5t-66 -23.5 t-23 -56.5t23 -56.5t66 -23.5zM175 524q37 0 56 21t19 49t-19 49t-56 21t-56 -21t-19 -49t19 -49t56 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    unicode: "\uF66A",
    horizAdvX: 354,
    d: "M134 303l83 134q-20 -8 -41 -8q-65 0 -103.5 40.5t-38.5 96.5q0 57 38.5 98.5t102.5 41.5t102.5 -42t38.5 -98q0 -38 -28 -87l-121 -198zM175 471q44 0 70.5 28t26.5 67q0 40 -26.5 69t-70.5 29t-70.5 -29t-26.5 -69q0 -39 26.5 -67t70.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 551,
    d: "M427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5 t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "euro.alt",
    horizAdvX: 739,
    d: "M674 147l36 -34q-106 -125 -259 -125q-131 0 -220 78.5t-114 203.5h-87v47h81q-1 10 -1 33q0 22 1 33h-81v47h87q25 124 115 203t219 79q151 0 255 -122l-38 -31q-35 45 -94 73.5t-123 28.5q-108 0 -181.5 -66t-96.5 -165h362v-47h-370q-1 -11 -1 -33q0 -23 1 -33h328 v-47h-320q23 -99 96 -165t182 -66q68 0 126 30.5t97 77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet.alt",
    horizAdvX: 500,
    d: "M104 350q0 61 42.5 103.5t103.5 42.5t103.5 -42.5t42.5 -103.5t-42.5 -103.5t-103.5 -42.5t-103.5 42.5t-42.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph.alt",
    horizAdvX: 505,
    d: "M295 652v-652h-52v700h174v-700h-52v652h-70zM56 513q0 77 55 132t132 55v-374q-77 0 -132 55t-55 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fj",
    horizAdvX: 523,
    d: "M23 408v48h98v162q0 66 45.5 108t111.5 42t111.5 -42t45.5 -108v-26q0 -11 -7.5 -18.5t-18.5 -7.5t-18.5 7.5t-7.5 18.5v14q0 47 -27 79t-78 32t-78 -32t-27 -79v-150h117v-48h-117v-408h-52v408h-98zM253 -221l20 45q24 -15 46 -15q17 0 29 3.5t23.5 20.5t11.5 47v576 h52v-584q0 -57 -32.5 -85.5t-75.5 -28.5q-19 0 -37.5 5t-27.5 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ft",
    horizAdvX: 647,
    d: "M173 456h224v147h52v-147h155v-48h-155v-280q0 -89 80 -89q16 0 33 5.5t26 10.5l9 5l20 -45q-44 -27 -90 -27q-63 0 -96.5 37t-33.5 96v287h-224v-408h-52v408h-98v48h98v179q0 63 36.5 98t86.5 35q47 0 89 -22l-22 -45q-27 16 -58 16q-80 0 -80 -98v-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave.alt",
    horizAdvX: 551,
    d: "M427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5 t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84zM175 675l39 37l149 -149l-35 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute.alt",
    horizAdvX: 551,
    d: "M345 712l35 -35l-150 -147l-34 33zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23 t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex.alt",
    horizAdvX: 551,
    d: "M427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5 t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84zM115 567l160 115l160 -115l-30 -37l-130 96l-130 -96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde.alt",
    horizAdvX: 551,
    d: "M427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5 t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84zM158 563l-42 25q1 3 2.5 8t9 17.5t17.5 22t28 17.5t40 8q26 0 65 -22t55 -22q21 0 34.5 12.5t16.5 24.5l3 12l42 -25q-1 -3 -2.5 -8t-9 -17.5t-17.5 -22t-28 -17.5t-40 -8q-26 0 -65 22t-55 22 q-21 0 -34.5 -12t-16.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis.alt",
    horizAdvX: 551,
    d: "M427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5 t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84zM146 604q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28zM327 604q0 16 11.5 28t28.5 12t28.5 -12t11.5 -28t-11.5 -28t-28.5 -12t-28.5 12t-11.5 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring.alt",
    horizAdvX: 551,
    d: "M427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5 t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84zM178 641q0 41 29 70t70 29t70 -29t29 -70t-29 -70t-70 -29t-70 29t-29 70zM219 641q0 -25 16.5 -41.5t41.5 -16.5t42 16.5t17 41.5t-17 42t-42 17t-41.5 -17t-16.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron.alt",
    horizAdvX: 551,
    d: "M427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5 t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84zM118 583v48h302v-48h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve.alt",
    horizAdvX: 551,
    d: "M427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5zM432 456h47v-456h-47v84q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5 t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84zM140 700h50v-9.5t4.5 -21t12.5 -27t26.5 -21t43.5 -9.5t43.5 9t26.5 22t12.5 26t4.5 22v9h50q0 -5 -1 -14.5t-8.5 -32.5t-20.5 -41t-41 -32.5t-66 -14.5t-66 14t-41 33.5t-20.5 39.5t-8.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek.alt",
    horizAdvX: 551,
    d: "M432 14v70q-2 -4 -6.5 -10.5t-19.5 -23t-33 -29t-48.5 -23t-63.5 -10.5q-96 0 -160.5 67.5t-64.5 172.5t64.5 172.5t160.5 67.5q33 0 63 -10t49 -24t33 -28t20 -24l6 -10v84h47v-456h-1q-5 -1 -14.5 -5t-26 -13t-27.5 -26t-11 -37q0 -21 12 -34t34 -13l34 6v-47 q-17 -6 -39 -6q-37 0 -62 24.5t-25 61.5q0 33 19.5 58.5t39.5 34.5zM427 145v166q-2 4 -6 11.5t-18.5 25.5t-32 32t-47 25.5t-61.5 11.5q-76 0 -124 -54t-48 -135t48 -135t124 -54q32 0 61 11t47.5 26.5t32 31t19.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum_tnum",
    d: "M291 712q65 0 115 -30.5t79 -82.5t44 -115t15 -134t-15 -134t-44 -115t-79 -82.5t-115 -30.5t-115 30.5t-80 82.5t-45 115t-15 134t15 134t45 115t80 82.5t115 30.5zM291 39q68 0 114.5 48.5t65.5 116t19 146.5t-19 146.5t-65.5 116t-114.5 48.5t-115 -48.5t-66.5 -116 t-19.5 -146.5t19.5 -146.5t66.5 -116t115 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum_tnum",
    d: "M91 497l255 203h43v-700h-52l-1 626l-214 -169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum_tnum",
    d: "M82 0l266 335q2 2 13.5 16t17 21t16 22.5t16.5 27t13 27t10 31.5t3 32q0 66 -39.5 107.5t-112.5 41.5q-34 0 -62.5 -12.5t-45 -30.5t-28.5 -36t-16 -30l-4 -13l-50 19q2 6 6 16.5t20.5 37t37.5 47t59 37t83 16.5q93 0 149.5 -56t56.5 -144q0 -20 -5.5 -41.5t-12.5 -38 t-18.5 -36t-18.5 -29.5t-17.5 -24t-11.5 -15l-222 -280h315v-48h-418z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum_tnum",
    d: "M436 522q0 61 -41.5 100t-105.5 39q-33 0 -60.5 -10.5t-43 -25.5t-26 -30.5t-14.5 -26.5l-4 -10l-48 20q2 5 6 14.5t19.5 32.5t35.5 40.5t56 32t79 14.5q86 0 142.5 -54t56.5 -136q0 -32 -10 -61t-24.5 -47t-29 -31.5t-24.5 -18.5l-10 -6q5 -1 12.5 -4t26.5 -15.5t34 -30 t27 -50.5t12 -74q0 -89 -62.5 -142.5t-155.5 -53.5q-47 0 -87 16t-63 38t-39.5 44.5t-22.5 38.5l-6 16l49 24q1 -5 4.5 -13.5t17 -30.5t30.5 -38.5t48.5 -30t68.5 -13.5q73 0 119.5 40.5t46.5 104.5q0 67 -39.5 106.5t-116.5 39.5h-41v52h36q66 0 106.5 39.5t40.5 100.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum_tnum",
    d: "M8 199l361 501h50v-453h97v-48h-97v-199h-52v199h-359zM101 247h266v370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum_tnum",
    d: "M526 218q0 -103 -67.5 -166.5t-163.5 -63.5q-45 0 -84.5 15t-63 36t-40.5 42t-23 36l-7 15l47 26q2 -5 5.5 -13t18 -28.5t32.5 -36t48.5 -28.5t66.5 -13q74 0 125.5 50.5t51.5 128.5q0 79 -50 129t-129 50q-48 0 -94 -20.5t-68 -40.5l-22 -21v385h387v-48h-335v-241 q62 37 134 37q100 0 165.5 -63t65.5 -167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum_tnum",
    d: "M371 694l-170 -278q39 23 93 23q101 0 162.5 -67t61.5 -156t-61.5 -158.5t-162.5 -69.5t-162.5 69t-61.5 157q0 61 34 126q16 29 72 124.5t104 175.5l49 81zM294 388q-75 0 -122.5 -47t-47.5 -125q0 -75 48.5 -126t121.5 -51t121.5 51t48.5 126t-48 123.5t-122 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum_tnum",
    d: "M84 652v48h454l-368 -711l-44 24l331 639h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum_tnum",
    d: "M290 712q88 0 141 -55.5t53 -128.5q0 -51 -25 -91.5t-63 -62.5q50 -24 81 -72t31 -109q0 -86 -61 -145.5t-157 -59.5t-157 59.5t-61 145.5q0 61 31 109t81 72q-38 22 -63 62.5t-25 91.5q0 73 53 128.5t141 55.5zM290 39q73 0 118.5 43.5t45.5 110.5t-45.5 110t-118.5 43 t-118.5 -43t-45.5 -110t45.5 -110.5t118.5 -43.5zM290 393q59 0 99.5 36.5t40.5 98.5t-40.5 97.5t-99.5 35.5t-99.5 -35.5t-40.5 -97.5t40.5 -98.5t99.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum_tnum",
    d: "M215 9l164 275q-39 -23 -93 -23q-101 0 -162.5 67.5t-61.5 155.5t61.5 158t162.5 70t162.5 -69t61.5 -157q0 -61 -34 -126l-219 -378zM286 312q75 0 122.5 47t47.5 125q0 75 -48.5 126t-121.5 51t-121.5 -51t-48.5 -126t48 -123.5t122 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onum_pnum",
    horizAdvX: 548,
    d: "M274 468q102 0 172 -69t70 -171t-70 -171t-172 -69t-172 69t-70 171t70 171t172 69zM274 39q79 0 133.5 55.5t54.5 133.5t-54.5 133.5t-133.5 55.5t-133.5 -55.5t-54.5 -133.5t54.5 -133.5t133.5 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onum_pnum",
    horizAdvX: 339,
    d: "M22 305l195 157h38v-462h-52v384l-149 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onum_pnum",
    horizAdvX: 458,
    d: "M324 198l-149 -150h219v-48h-342l201 194q73 71 73 119t-28 76t-77 28q-41 0 -72 -25t-45 -65l-47 20q21 56 64 88.5t100 32.5q70 0 114.5 -42t44.5 -113q0 -52 -56 -115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onum_pnum",
    horizAdvX: 503,
    d: "M386 289q0 54 -39.5 91t-98.5 37q-32 0 -58.5 -10.5t-42 -25t-26 -29t-14.5 -24.5l-4 -11l-47 21q2 5 5.5 14t19.5 31.5t35.5 39.5t55 31t76.5 14q81 0 136.5 -51.5t55.5 -127.5q0 -29 -9 -55t-22 -42t-26.5 -28t-22 -17t-9.5 -5q4 -1 11 -4t25 -15t32 -29t25 -48t11 -69 q0 -84 -61 -135.5t-150 -51.5q-46 0 -85 15.5t-61 37.5t-38 44.5t-22 38.5l-5 15l49 22q1 -5 4 -13t16 -29t29.5 -37.5t46.5 -29.5t66 -13q70 0 113.5 38.5t43.5 97.5q0 66 -38.5 101t-101.5 35h-44v48h24q63 0 104 36t41 92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onum_pnum",
    horizAdvX: 528,
    d: "M10 0l339 456h41v-408h108v-48h-108v-198h-52v198h-328zM106 48h232v313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onum_pnum",
    horizAdvX: 536,
    d: "M490 11q0 -99 -65 -160t-155 -61q-46 0 -85 14.5t-61.5 35t-38.5 40.5t-21 34l-6 15l48 23q1 -5 4.5 -12t16.5 -26.5t29.5 -34t47 -26.5t66.5 -12q71 0 118.5 48t47.5 122q0 75 -49.5 122.5t-124.5 47.5q-46 0 -90 -20.5t-64 -40.5l-21 -20v356h371v-48h-319v-216 q54 40 126 40q95 0 160 -61t65 -160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onum_pnum",
    horizAdvX: 545,
    d: "M351 703l-170 -278q39 23 93 23q101 0 162.5 -67t61.5 -156t-61.5 -158.5t-162.5 -69.5t-162.5 69t-61.5 157q0 61 34 126q16 29 72 124.5t104 176.5l49 80zM274 397q-75 0 -122.5 -47t-47.5 -125q0 -75 48.5 -126t121.5 -51t121.5 51t48.5 126t-48 123.5t-122 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onum_pnum",
    horizAdvX: 483,
    d: "M37 408v48h440l-340 -656l-43 23l299 585h-356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onum_pnum",
    horizAdvX: 540,
    d: "M270 712q88 0 141 -55.5t53 -128.5q0 -51 -25 -91.5t-63 -62.5q50 -24 81 -72t31 -109q0 -86 -61 -145.5t-157 -59.5t-157 59.5t-61 145.5q0 61 31 109t81 72q-38 22 -63 62.5t-25 91.5q0 73 53 128.5t141 55.5zM270 39q73 0 118.5 43.5t45.5 110.5t-45.5 110t-118.5 43 t-118.5 -43t-45.5 -110t45.5 -110.5t118.5 -43.5zM270 393q59 0 99.5 36.5t40.5 98.5t-40.5 97.5t-99.5 35.5t-99.5 -35.5t-40.5 -97.5t40.5 -98.5t99.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onum_pnum",
    horizAdvX: 520,
    d: "M221 -176l128 236q-34 -22 -90 -22q-98 0 -156 64t-58 151t58.5 151t155.5 64t155.5 -64t58.5 -151q0 -44 -23 -95q-15 -32 -61 -122t-85 -164l-39 -73zM259 89q75 0 117.5 49t42.5 115t-42.5 115t-117.5 49t-117.5 -49t-42.5 -115t42.5 -115t117.5 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onum_tnum",
    d: "M290 468q102 0 172 -69t70 -171t-70 -171t-172 -69t-172 69t-70 171t70 171t172 69zM290 39q79 0 133.5 55.5t54.5 133.5t-54.5 133.5t-133.5 55.5t-133.5 -55.5t-54.5 -133.5t54.5 -133.5t133.5 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onum_tnum",
    d: "M108 273l235 189h38v-462h-52v386l-189 -153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onum_tnum",
    d: "M396 198l-149 -150h219v-48h-342l201 194q73 71 73 119t-28 76t-77 28q-41 0 -72 -25t-45 -65l-47 20q21 56 64 88.5t100 32.5q70 0 114.5 -42t44.5 -113q0 -52 -56 -115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onum_tnum",
    d: "M423 289q0 54 -39.5 91t-98.5 37q-32 0 -58.5 -10.5t-42 -25t-26 -29t-14.5 -24.5l-4 -11l-47 21q2 5 5.5 14t19.5 31.5t35.5 39.5t55 31t76.5 14q81 0 136.5 -51.5t55.5 -127.5q0 -29 -9 -55t-22 -42t-26.5 -28t-22 -17t-9.5 -5q4 -1 11 -4t25 -15t32 -29t25 -48t11 -69 q0 -84 -61 -135.5t-150 -51.5q-46 0 -85 15.5t-61 37.5t-38 44.5t-21 38.5l-6 15l49 22q1 -5 4 -13t16 -29t29.5 -37.5t46.5 -29.5t66 -13q70 0 113.5 38.5t43.5 97.5q0 66 -38.5 101t-101.5 35h-44v48h24q63 0 104 36t41 92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onum_tnum",
    d: "M14 0l339 456h41v-408h108v-48h-108v-198h-52v198h-328zM110 48h232v313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onum_tnum",
    d: "M518 11q0 -99 -65 -160t-155 -61q-46 0 -85 14.5t-61.5 35t-38.5 40.5t-21 34l-6 15l48 23q1 -5 4.5 -12t16.5 -26.5t29.5 -34t47 -26.5t66.5 -12q71 0 118.5 48t47.5 122q0 75 -49.5 122.5t-124.5 47.5q-46 0 -90 -20.5t-64 -40.5l-21 -20v356h371v-48h-319v-216 q54 40 126 40q95 0 160 -61t65 -160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onum_tnum",
    d: "M371 694l-170 -278q39 23 93 23q101 0 162.5 -67t61.5 -156t-61.5 -158.5t-162.5 -69.5t-162.5 69t-61.5 157q0 61 34 126q16 29 72 124.5t104 175.5l49 81zM294 388q-75 0 -122.5 -47t-47.5 -125q0 -75 48.5 -126t121.5 -51t121.5 51t48.5 126t-48 123.5t-122 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onum_tnum",
    d: "M93 408v48h440l-340 -656l-43 23l299 585h-356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onum_tnum",
    d: "M290 712q88 0 141 -55.5t53 -128.5q0 -51 -25 -91.5t-63 -62.5q50 -24 81 -72t31 -109q0 -86 -61 -145.5t-157 -59.5t-157 59.5t-61 145.5q0 61 31 109t81 72q-38 22 -63 62.5t-25 91.5q0 73 53 128.5t141 55.5zM290 39q73 0 118.5 43.5t45.5 110.5t-45.5 110t-118.5 43 t-118.5 -43t-45.5 -110t45.5 -110.5t118.5 -43.5zM290 393q59 0 99.5 36.5t40.5 98.5t-40.5 97.5t-99.5 35.5t-99.5 -35.5t-40.5 -97.5t40.5 -98.5t99.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onum_tnum",
    d: "M250 -176l128 236q-34 -22 -90 -22q-98 0 -156 64t-58 151t58.5 151t155.5 64t155.5 -64t58.5 -151q0 -44 -23 -95q-15 -32 -61 -122t-85 -164l-39 -73zM288 89q75 0 117.5 49t42.5 115t-42.5 115t-117.5 49t-117.5 -49t-42.5 -115t42.5 -115t117.5 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Circle",
    horizAdvX: 844,
    d: "M62 350q0 151 104.5 256.5t254.5 105.5q151 0 256 -105.5t105 -256.5q0 -150 -105.5 -256t-255.5 -106t-254.5 106t-104.5 256zM114 349q0 -127 90 -217t217 -90q128 0 218 90t90 217t-90.5 217.5t-217.5 90.5t-217 -90t-90 -218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CircleDotted",
    horizAdvX: 844,
    d: "M282 350q0 57 41 98.5t98 41.5t98.5 -41.5t41.5 -98.5t-41.5 -98t-98.5 -41q-58 0 -98.5 40.5t-40.5 98.5zM62 350q0 151 104.5 256.5t254.5 105.5q151 0 256 -105.5t105 -256.5q0 -150 -105.5 -256t-255.5 -106t-254.5 106t-104.5 256zM114 349q0 -127 90 -217t217 -90 q128 0 218 90t90 217t-90.5 217.5t-217.5 90.5t-217 -90t-90 -218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Trash",
    horizAdvX: 844,
    d: "M45 700h754l-133 -700h-488zM335 647l10 -172h153l11 172h-174zM557 647l-11 -172h150l30 172h-169zM117 647l31 -172h149l-10 172h-170zM348 431l10 -164h128l10 164h-148zM544 431l-10 -164h126l29 164h-145zM155 431l29 -164h126l-10 164h-145zM360 223l11 -170h102 l10 170h-123zM531 223l-10 -170h101l30 170h-121zM192 223l29 -170h102l-11 170h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "EuropaType",
    horizAdvX: 776,
    d: "M619 194l24 -64q-32 -21 -92 -38q-8 13 -24 13q-12 0 -20.5 -8.5t-8.5 -20.5t8.5 -20.5t20.5 -8.5q11 0 19.5 8t9.5 19q43 12 94 38l24 -63q-12 -7 -33 -17t-82 -26.5t-118 -16.5q-21 30 -23 84q0 41 11 67q49 0 96.5 13.5t70.5 26.5zM211 408h363q-3 63 -52 109t-130 46 q-77 0 -126 -46t-55 -109zM391 712q153 0 245.5 -101.5t92.5 -264.5q0 -4 -3 -55h-514q9 -60 61.5 -102.5t133.5 -47.5q-11 -33 -11 -69q2 -50 21 -84h-6q-160 0 -262 105t-102 257t96 257t248 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period.tabular",
    d: "M250 28q0 16 12 28t28 12t28 -12t12 -28t-12 -28t-28 -12t-28 12t-12 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space.tabular"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "abreve.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "amacron.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aring.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "adieresis.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "atilde.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "acircumflex.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "aacute.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "agrave.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    g2: "a.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0109",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "d",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "abreve.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "amacron.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aring.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "adieresis.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "atilde.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "acircumflex.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "aacute.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "agrave.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    g2: "a.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0109",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "d",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1EF3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1E83",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1E81",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0177",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0175",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "w",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EF3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E83",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E82",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E81",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E80",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0177",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0175",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0174",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0164",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0162",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "y",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "w",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "W",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "T",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "v",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aogonek.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "abreve.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "amacron.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aring.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "adieresis.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "atilde.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "acircumflex.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "aacute.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "agrave.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "a.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0109",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "'",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\"",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1EF2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0178",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0176",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aogonek.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "abreve.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "amacron.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aring.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "adieresis.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "atilde.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "acircumflex.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "aacute.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "agrave.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "a.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0133",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0108",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u203A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2019",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201D",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "g",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "'",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\"",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "g",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "d",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u201D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2019",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "'",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\"",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "g",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "d",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "j",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u201D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u2019",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aogonek.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "abreve.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "amacron.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aring.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "adieresis.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "atilde.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "acircumflex.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "aacute.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "agrave.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "a.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0153",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0151",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u014F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u014D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u011B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0119",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0117",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0115",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0113",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u010B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0109",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0107",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xEA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "o",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "e",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "c",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u203A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2019",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0109",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "q",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "g",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "d",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "q",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "g",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0138",
    u2: "d",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u201D",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u2019",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "'",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\"",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u201D",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u2019",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "'",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\"",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201D",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2019",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "'",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\"",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\u201D",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\u2019",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "'",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013F",
    u2: "\"",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u201D",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2019",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "'",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\"",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "j",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u201D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u2019",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "'",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\"",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "q",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "g",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "d",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "q",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "g",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "d",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "q",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "g",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "d",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ",",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "j",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "j",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015D",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "j",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "j",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "v",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ";",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ":",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "-",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "v",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ";",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ":",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "-",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ".",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u203A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ";",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "-",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0177",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0177",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "-",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u203A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ";",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u203A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u201E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\u201A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xBB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ";",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ":",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: ".",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "v",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "q",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ";",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ":",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "-",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF3",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF3",
    u2: ",",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "abreve.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "amacron.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aring.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "adieresis.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "atilde.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "acircumflex.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "aacute.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "agrave.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    g2: "a.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0109",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0102",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0100",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "d",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E83",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E82",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E81",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u1E80",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0175",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0174",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0164",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0162",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "W",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "T",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aogonek.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "abreve.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "amacron.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aring.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "adieresis.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "atilde.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "acircumflex.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "aacute.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "agrave.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "a.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0109",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0102",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0100",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC6",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "g",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E83",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E82",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E81",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u1E80",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0175",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0174",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0164",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0162",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u1E82",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u1E80",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0174",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0164",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0162",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0104",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0102",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0100",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\xC0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\u201D",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\u2019",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "g",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "'",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ff",
    u2: "\"",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "agrave.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aacute.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "acircumflex.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "atilde.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "adieresis.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aring.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "amacron.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "abreve.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aogonek.alt",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum_pnum",
    u2: ".",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum_pnum",
    u2: ",",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.onum_pnum",
    u2: ".",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.onum_pnum",
    u2: ",",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcedilla",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "Y,Ycircumflex,Ydieresis,Ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcedilla,Lcaron,Ldot,Lslash",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "r,racute,rcedilla,rcaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,Tbar",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "y,ydieresis,ycircumflex,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "r,racute,rcedilla,rcaron",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "C,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcedilla,Omacron,Obreve,Ohungarumlaut",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Ycircumflex,Ydieresis,Ygrave",
    g2: "i,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,ij",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    g2: "T,Tcedilla,Tcaron,Tbar",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,ff",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcedilla,kgreenlandic",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    g2: "w,wcircumflex,wgrave,wacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "s,sacute,scircumflex,scedilla,scaron",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcedilla,rcaron",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oe",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,ydieresis,ycircumflex,ygrave",
    g2: "a.alt,agrave.alt,aacute.alt,acircumflex.alt,atilde.alt,adieresis.alt,aring.alt,amacron.alt,abreve.alt,aogonek.alt",
    k: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropaLight);
export default __webpack_public_path__ + "static/media/Europa-Light.d5a79332e920b7c508336947a60f0b35.svg";
export { ForwardRef as ReactComponent };